import {
  Box,
  Dialog,
  DialogActions,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  ListSubheader,
  MenuItem,
  Modal,
  Popover,
  Select,
  Stack,
  TextareaAutosize,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../comman/Sidebar";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import isEqual from "lodash/isEqual";
import moment from "moment/moment";
import {
  CREATE_UPDATE_BILLING_STATEMENT_DETAILS_URL,
  CREATE_UPDATE_BILLING_STATEMENT_URL,
  DELETE_BILLING_STATEMENT_BY_ID,
  GET_BILLING_STATEMENT_BY_ID_URL,
  GET_BILLING_STATEMENT_DETAILS_BY_ID_URL,
  SYSTEM_LOG_INSERT_URL,
  UPDATE_BILLING_STATUS_URL,
  GET_PROJECT_DETAILS_BY_ID_URL,
  GET_ORPHANED_BROKER_DETAILS_LIST_URL,
} from "../../constants/ApiRoute";
import {
  authHeader,
  getLogUserId,
  getLogUserRole,
} from "../comman/MainFunction";
import ErrorIcon from "@mui/icons-material/Error";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import API from "../comman/API";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUserDetails, getPerDiemList } from "../../redux/action";
import * as types from "../../redux/action/ActionType";

import BillingAttachment from "../model/BillingAttachment";
import {
  CircleGreenFillIcon,
  CircleGreenIcon,
  CircleIcon,
} from "../../images/SvgIcons";
import CircleGreenIconSvg from "../../images/Nodes-green-circle.svg";
import {
  ADMIN_BILLING_LIST,
  BILLING_STATEMENT_LIST_ROUTE,
  PAGE_NOT_FOUND_PATH,
} from "../../constants/RoutePath";
import { useToast } from "../comman/CustomMessages";
import CustomPageLoading from "../comman/CustomPageLoading";
import Navbar from "../comman/Navbar";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ADMIN_BILLING_STATEMENT_SELECT } from "../../redux/action/ActionType";
import { useTheme } from "@emotion/react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // Import UTC plugin
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc); // Enable UTC handling in Day.js
dayjs.extend(timezone);

const steps = [
  "Statement Open",
  "Statement Closed",
  "Invoice Started",
  "Invoice Closed",
];
const billTypeList = [
  { id: 1, name: "Abstract" },
  { id: 2, name: "Mineral" },
  { id: 3, name: "Tract" },
  { id: 4, name: "Cursory Title" },
  { id: 5, name: "Due Dilligence" },
  { id: 6, name: "Area Checks" },
  { id: 7, name: "Curative" },
  { id: 8, name: "Other" },
];
const initialBillDetail = {
  hProjectName: "",
  hCustomerName: "",
  hbokerName: "",
  hStatus: "Statement Open",
  hHours: "0.00",
  hCharges: "0.00",
  hMiles: "0",
  hMilegeRate: "0.00",
  hperdiem: "0.00",
  hlodging: "0.00",
  hcopies: "0.00",
  hmisc: "0.00",
  hDayRate: "0.00",
  hStartDate: "",
  hEndDate: "",
  huserId: "",
  hperiodKey: "",
  hprojectID: "",
  hCustomerId: "",
};
export default function BillingStatements(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { id } = useParams();
  console.log(id, "bidbidbidbid", useParams());
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const [isInitialized, setIsInitialized] = useState(false);
  const [isOrphanedValue, setIsOrphanedValue] = useState(true);
  const [activeStateClose, setActiveStateClose] = useState("");

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const { billStatementId = 1 } = props;
  const pathname = window.location.pathname;
  const dispatch = useDispatch();
  const perList = deCryptFun(useSelector((s) => s.AllPerDiemListReducer));
  const BillingStatementFilterReducer = useSelector(
    (s) => s.BillingStatementFilterReducer
  );
  const {
    BillableOfficePerDiem,
    BillableTravelPerDiem,
    BillingDayRate,
    MileageRate,
    PayableDayRate,
  } =
    (perList && JSON.parse(perList).data && JSON.parse(perList).data[0]) || [];

  const parts = pathname && pathname.split("/");
  const lastPart = parts[parts.length - 1];
  const billid = isNaN(lastPart) ? null : lastPart;
  console.log("bill id", billid);
  // Now you can use billingStatementDetail
  const showToast = useToast();
  const [formSaved, setFormSaved] = useState(true);
  const [changedFields, setChangedFields] = useState({});
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [showWarning, setShowWarning] = React.useState(false);
  const [periidemDropDown, setPeridiemDropDown] = useState("false");
  const [closeBillingAlert, setCloseBillingAlert] = React.useState(false);
  const [backNavigateArrow, setBackNavigateArrow] = React.useState(false);
  const [warningHighlighted, setWarningHighlightColor] = React.useState(false);
  console.log(showWarning, "showWarningshowWarning");
  console.log(formSaved, "formSavedformSaved");
  console.log(changedFields, "changedFieldschangedFields");
  console.log(warningHighlighted, "warningHighlightedwarningHighlighted");
  console.log(isFormDirty, "isFormDirtyisFormDirty");
  console.log(backNavigateArrow, "backNavigateArrowbackNavigateArrow");
  const [openModal, setOpenModal] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  console.log(activeStep, "accccccccccc");
  const [completed, setCompleted] = React.useState({});
  const [billingStatus, setBillingStatus] = useState(false);
  const [closeStatementButton, setCloseStatementButton] = useState(false);
  const [billingStatementDetail, setBillingStatementDetail] =
    useState(initialBillDetail);
  const [noOfLineItems, setNoOfLineItem] = useState(0);
  const [initialValues, setInitialvalues] = useState([]);
  const [valUpdate, setValUpdate] = useState(false);
  const [isNewitemAdded, setIsNewitemAdded] = useState(false);
  const [itemRemoveConfirmItem, setItemRemoveConfirmItem] =
    React.useState(null);
  const [itemRemoveConfirmStatus, setItemRemoveConfirmStatus] =
    React.useState(false);
  const [responseBill, setResponseBill] = useState([]);
  //Attachment
  const [openAttachmentFilter, setOpenAttachmentFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [brokerDetailsVal, setBrokerDetailsval] = useState([]);
  const [projectDetailsval, setProjectDetailsVal] = useState([]);
  const [orphanedBillingDetail, setOrphanedBillingDetail] = useState("");
  const [isFormUpdate, setIsFormUpdate] = useState(false);
  const [isOrphanentRemovedUser, setIsOrphanentRemovedUser] = useState(false);

  console.log(
    orphanedBillingDetail,
    "orphanedBillingDetailorphanedBillingDetail"
  );
  console.log(brokerDetailsVal, "orphanedBillingDetailorphanedBillingDetail");

  const [dayRateMillageRateForBilling, setDayRateMillageRateForBilling] =
    useState({
      brokerBilling: { dayRate: 0, millageRate: 0 },
      statementBilling: { dayRate: 0, millageRate: 0 },
      removedBrokerBilling: { dayRate: 0, millageRate: 0 },
    });
  const [currentBillingStatus, setCurrentBillingStatus] = useState("");

  // if (activeStateClose != 2) {
  //   localStorage.setItem("MILSTATEMENT", MileageRate);
  // }
  const [milegaePrev, setMileagePrev] = useState(
    localStorage.getItem("MILSTATEMENT")
  );
  const [reOpenLoading, setReopenLoading] = useState(false);

  const [DAYPrev, setDAyPrev] = useState(localStorage.getItem("DAYSTATEMENT"));
  console.log(dayRateMillageRateForBilling, "brokerDetailsValbrokerDetailsVal"); //BillableOfficePerDiem
  console.log(currentBillingStatus, "projectDetailsvalprojectDetailsval");
  console.log(DAYPrev, "DAYPrevDAYPrev");
  const [saveLoading, setSaveloading] = React.useState(false);
  //  let noOfLineItems =
  //  (billingStatementDetail.hEndDate).diff(billingStatementDetail.hStartDate,"days");
  const generateInitialValues = (numberOfLineItems, startDate) => {
    const initialValues = {};
    const startMoment = moment(startDate, "MM/DD/YYYY").local().startOf("day");
    for (let i = 1; i <= numberOfLineItems; i++) {
      const currentMoment = startMoment
        .clone()
        .add(i - 1, "days")
        .startOf("day");
      initialValues[`lineItem${currentMoment.format("MM/DD/YYYY")}`] = [
        {
          billingType: 0,
          dayRate: "",
          hours: "0.00",
          miles: "0",
          lodging: "0.00",
          description: "",
          perdiemRate: "$0.00",
          perDiem: "0.00",
          copies: "0.00",
          misc: "0.00",
          date: currentMoment.format("MM/DD/YYYY"),
          billingStatementDetailsId: 0,
          IsOfficePerDiem: false,
          IsTravelPerDiem: false,
        },
      ];
    }

    return initialValues;
  };
  //  let initialValues={}
  // useEffect(() => {
  //   initialValues = generateInitialValues(
  //     noOfLineItems,
  //     billingStatementDetail.hStartDate
  //   );
  // }, [billingStatementDetail.hStartDate]);
  useEffect(() => {
    if (Object.keys(initialValues).length > 0) setIsInitialized(true);
  }, [initialValues]);
  const lineItemValidationSchema = Yup.object().shape({
    billingType: Yup.string().required("Billing type is required"),
  });

  const validationSchema = Yup.object().shape(
    Object.keys(initialValues)
      .filter((key) => key.startsWith("lineItem"))
      .reduce((schema, key) => {
        schema[key] = Yup.array().of(lineItemValidationSchema);
        return schema;
      }, {})
  );

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    console.log("step", step);
    // setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  // const handleAttachmentOpen = (val) => {
  //   setOpenAttachmentFilter(!openAttachmentFilter);
  // };

  const handleAttachmentOpen = (val) => {
    getBillingStatement();
    if (billingStatementDetail.hprojectID && activeStep == 0) {
      checkBillingProjectDetail(billingStatementDetail.hprojectID);
    }
    setTimeout(() => {
      if (isOrphanedValue) {
        setOpenAttachmentFilter(!openAttachmentFilter);
      }
    }, 1000);
  };

  const handleAttachmentClose = () => {
    setOpenAttachmentFilter(false);
  };

  const {
    handleSubmit,
    handleChange,
    setValues,
    setFieldTouched,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
    setFieldValue,
    setTouched,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setFormSaved(true);
      // upsertBillingDetailsFun(values);
    },
  });
  console.log(values, "value of item");
  console.log(initialValues, "initialValues");
  const updateFormValues = (updatedValues) => {
    setValues({
      ...values, // Spread existing values
      ...updatedValues, // Spread updated values
    });
  };

  const handleOnClickPer = (e, key, index, type) => {
    console.log("Callinggggggg", type);
    setPeridiemDropDown(type);
  };

  const handleChange1 = (event, key, index) => {
    const { name, value } = event.target;

    // console.log(name, " handleChange1 one name");
    // console.log(value, "handleChange1 two value");
    // console.log(key, "handleChange1 three key");
    // console.log(index, "handleChange1 four index");
    // console.log(values, "handleChange1 five initialValues");

    handleChange(event);
    const fieldName = name.split(".").pop();
    const fieldKey = `${key}[${index}].${fieldName}`;
    console.log(fieldKey, "fileddddkeyyyyy");
    // if (
    //   fieldName &&
    //   brokerDetailsVal[0]?.PayableOfficePerDiem.toString() == value
    // ) {
    //   setPeridiemDropDown("IsOfficePerDiem");
    // } else if (
    //   fieldName &&
    //   brokerDetailsVal[0]?.PayableTravelPerDiem.toString() == value
    // ) {
    //   setPeridiemDropDown("IsTravelPerDiem");
    // } else {
    //   setPeridiemDropDown("IsEmpty");
    // }
    setChangedFields((prevState) => {
      const newState = { ...prevState };
      const isChanged = value !== values[key][index][fieldName];
      //const isChanged = value !== values[key][index][fieldName];
      console.log(isChanged, "fileddddkejjjjjjjjjjjjjjjjyyyyy");

      if (isChanged) {
        newState[fieldKey] = true;
        setIsFormDirty(true);
        setFormSaved(false);
      } else {
        delete newState[fieldKey];
        // setIsFormDirty(false);
      }

      return newState;
    }); // Mark form as unsaved on change
    console.log(
      isFormDirty,
      changedFields[`${key}[${index}].perDiemRate`],
      "lllllllooooooo"
    );
  };

  // Validation Custom Form
  // Validation Custom Form
  const handleChangeCustomHours = (e, key, index) => {
    const { name, value } = e.target;
    const floatRegex = /^(\d{0,2}(\.\d{0,2})?)$/;

    // Convert the value to a number if it passes the regex
    const numericValue = parseFloat(value);

    // Check if value is valid (either empty or matches the float pattern) and allow less than 24 hours
    if (
      (value === "" || floatRegex.test(value)) &&
      (numericValue <= 24 || value === "")
    ) {
      handleChange(e);
      setFormSaved(false);

      // Extract key and index from name for changedFields tracking
      const fieldKey = `${key}[${index}].hours`;

      setChangedFields((prevState) => {
        const newState = { ...prevState };

        // Check if the current value is different from the original value
        const isChanged = value !== values[key][index].hours;

        if (isChanged) {
          newState[fieldKey] = true;
        } else {
          delete newState[fieldKey];
        }

        return newState;
      });
    }
  };

  const handleChangeCustomFloatNumber = (e, key, index) => {
    const { name, value } = e.target;
    //const floatRegex = /^(0|[1-9]\d*)(\.\d{0,2})?$/; // Matches: 0, 1.0, 23.45, etc.
    const numericValue = parseFloat(value);
    const floatRegex = /^(\d{0,5}(\.\d{0,2})?)$/;
    if (
      !isNaN(value) &&
      (value === "" || floatRegex.test(value)) &&
      (numericValue <= 10000 || value === "")
    ) {
      handleChange(e);
      setFormSaved(false);
    }
    const fieldName = name.split(".").pop();
    const fieldKey = `${key}[${index}].${fieldName}`;
    console.log(fieldKey, "fileddddkeyyyyy");
    setChangedFields((prevState) => {
      const newState = { ...prevState };
      //const isChanged = value !== initialValues[key][index][fieldName];
      const isChanged = value !== values[key][index][fieldName];
      console.log(isChanged, "fileddddkeyyyyy");

      if (isChanged) {
        newState[fieldKey] = true;
      } else {
        delete newState[fieldKey];
      }

      return newState;
    });

    //   else {
    //     showToast("Must be a positive number up to 10, 000.", "error");
    // }
  };

  const handleChangeCustomIntNumber = (e, key, index) => {
    const { name, value } = e.target;
    const numericValue = parseInt(value);
    const floatRegex = /^\d{1,5}$/;
    if (
      !isNaN(value) &&
      (value === "" || floatRegex.test(value)) &&
      (numericValue <= 10000 || value === "")
    ) {
      handleChange(e);
      setFormSaved(false);
    }

    const fieldName = name.split(".").pop();
    const fieldKey = `${key}[${index}].${fieldName}`;
    setChangedFields((prevState) => {
      const newState = { ...prevState };
      //const isChanged = value !== initialValues[key][index][fieldName];
      const isChanged = value !== values[key][index][fieldName];

      if (isChanged) {
        newState[fieldKey] = true;
      } else {
        delete newState[fieldKey];
      }
      return newState;
    });

    //   else {
    //     showToast("Must be a positive number up to 10, 000.", "error");
    // }
  };

  //  const upsertBillingDetailsFun = async (values) => {
  //    console.log("val to submit", values);
  //    let postDataArrayTotal = [];
  //    let totalHours = 0;
  //    let totalMiles = 0;
  //    let totalPerDiem = 0;
  //    let totalCopies = 0;
  //    let totalLodging = 0;
  //    let totalMisc = 0;
  //    let totalMilege = 0;

  //    const filteredLineItems = Object.keys(values)
  //      .filter((key) => key.startsWith("lineItem"))
  //      .reduce((result, key) => {
  //        const filteredItems = values[key].filter((item) => item.billingType);
  //        if (filteredItems.length > 0) {
  //          result[key] = filteredItems;
  //        }
  //        return result;
  //      }, {});

  //    console.log(filteredLineItems);
  //    let postDataArray = [];
  //    Object.keys(filteredLineItems).forEach((key) => {
  //      filteredLineItems[key].forEach((item) => {
  //        console.log("inside item", item);
  //        const {
  //          lodging,
  //          billingType,
  //          hours,
  //          perDiem,
  //          dayRate,
  //          miles,
  //          misc,
  //          copies,
  //          mileageRate,
  //          total,
  //          date,
  //          perDiemRate,
  //          description,
  //          billingStatementDetailsId,
  //        } = item;

  //        // Ensure values are parsed as numbers
  //        const parsedHours = parseFloat(hours) || 0;
  //        const parsedMiles = parseFloat(miles) || 0;
  //        const parsedPerDiem = parseFloat(perDiem) || 0;
  //        const parsedCopies = parseFloat(copies) || 0;
  //        const parsedLodging = parseFloat(lodging) || 0;
  //        const parsedMisc = parseFloat(misc) || 0;
  //        const parsedMileageRate = parseFloat(mileageRate) || 0;

  //        totalHours += parsedHours;
  //        totalMiles += parsedMiles;
  //        totalPerDiem += parsedPerDiem;
  //        totalCopies += parsedCopies;
  //        totalLodging += parsedLodging;
  //        totalMisc += parsedMisc;
  //        totalMilege += parsedMileageRate;

  //        console.log("total hrs", totalHours, "totalPerDiem", totalPerDiem);

  //        setBillingStatementDetail((prevState) => ({
  //          ...prevState,
  //          hHours: totalHours.toFixed(2),
  //          hMiles: totalMiles.toString(),
  //          hperdiem: totalPerDiem.toFixed(2),
  //          hlodging: totalLodging.toFixed(2),
  //          hcopies: totalCopies,
  //          hMilegeRate: totalMilege.toFixed(2),
  //          hmisc: totalMisc.toFixed(2),
  //        }));

  //        let postData = {
  //          billingStatementDetailsId: billingStatementDetailsId,
  //          headerId: billid,
  //          billingType: billingType,
  //          date: date,
  //          hours: parsedHours,
  //          perDiemRate: perDiemRate,
  //          perDiem: calculatePerDiem(parsedHours, perDiemRate),
  //          lodging: parsedLodging,
  //          miles: parsedMiles,
  //          misc: parsedMisc,
  //          copies: parsedCopies,
  //          description: description,
  //        };

  //        postDataArray.push(postData);
  //        console.log(
  //          `Lodging: ${lodging}, Billing Type: ${billingType}, Hours: ${hours}`
  //        );
  //      });
  //    });

  //    let firstData = postDataArray[0];
  //    const {
  //      hProjectName,
  //      hCustomerName,
  //      hbokerName,
  //      hStatus,
  //      hHours,
  //      hCharges,
  //      hMiles,
  //      hMilegeRate,
  //      hperdiem,
  //      hlodging,
  //      hcopies,
  //      hmisc,
  //      hDayRate,
  //      hStartDate,
  //      huserId,
  //      hperiodKey,
  //      hprojectID,
  //      hEndDate,
  //    } = billingStatementDetail;

  //    let postData = {
  //      billingStatementId: billid,
  //      userId: getLogUserId(),
  //      periodKey: hperiodKey,
  //      projectId: hprojectID,
  //      statusId: hStatus == "Statement closed" ? 2 : 1,
  //      billingStart: hStartDate,
  //      billingEnd: hEndDate,
  //      hours: totalHours,
  //      dayRate: hDayRate,
  //      perDiem: totalPerDiem,
  //      lodging: totalLodging,
  //      miles: totalMiles,
  //      misc: totalMisc,
  //      copies: totalCopies,
  //      mileageRate: totalMilege,
  //      total: parseFloat((totalHours / 8) * BillingDayRate).toFixed(2),
  //    };

  //    const configone = {
  //      method: "POST",
  //      url: CREATE_UPDATE_BILLING_STATEMENT_URL,
  //      headers: authHeader(),
  //      data: {
  //        webString: enCryptFun(JSON.stringify(postData)),
  //      },
  //    };

  //    const config = {
  //      method: "POST",
  //      url: CREATE_UPDATE_BILLING_STATEMENT_DETAILS_URL,
  //      headers: authHeader(),
  //      data: {
  //        webString: enCryptFun(JSON.stringify(firstData)),
  //      },
  //    };

  //    try {
  //      console.log("config", postDataArray);
  //      const response = await API(config);
  //      let decryptedResponse = deCryptFun(response.data);
  //      const parsedResponse = JSON.parse(decryptedResponse);

  //      if (parsedResponse.status == "Success") {
  //        console.log("updated");
  //        const response1 = await API(configone);
  //        let decryptedResponse1 = deCryptFun(response1.data);
  //        const parsedResponse1 = JSON.parse(decryptedResponse1);

  //        if (parsedResponse1.status == "Success") {
  //          showToast(parsedResponse1.message, "success");
  //          getBillStatementDetails();
  //          getBillingStatement();
  //        }
  //      }
  //    } catch (error) {
  //      if (error.response) {
  //        let { data } = error.response;
  //        let p = deCryptFun(data);
  //        let v = JSON.parse(p);
  //        showToast(v.message, "error");
  //      }
  //    }
  //  };
  const upsertBillingDetailsFun = async (values, keyvalue, itemId) => {
    setSaveloading(true);
    let postDataArrayTotal = [];
    let totalHours = 0;
    let totalMiles = 0;
    let totalPerDiem = 0;
    let totalCopies = 0;
    let totalLodging = 0;
    let totalMisc = 0;
    let totalMilege = 0;

    const filteredLineItems = Object.keys(values)
      .filter((key) => key.startsWith("lineItem"))
      .reduce((result, key) => {
        const filteredItems = values[key].filter((item) => item.billingType);
        if (filteredItems.length > 0) {
          result[key] = filteredItems;
        }
        return result;
      }, {});

    console.log("filteredLineItems", filteredLineItems);

    let postDataArray = [];
    Object.keys(filteredLineItems).forEach((key) => {
      filteredLineItems[key].forEach((item) => {
        console.log("inside item", item);
        const {
          lodging,
          billingType,
          hours,
          perDiem,
          dayRate,
          miles,
          misc,
          copies,
          mileageRate,
          total,
          date,
          perDiemRate,
          description,
          billingStatementDetailsId,
          IsTravelPerDiem,
          IsOfficePerDiem,
        } = item;
        console.log(
          parseFloat(perDiemRate),
          "parseFloat(perDiemRate)",
          parseInt(perDiemRate),
          perDiemRate
        );
        // Ensure values are parsed as numbers
        const parsedHours = parseFloat(hours) || 0;
        const parsedMiles = parseFloat(miles) || 0;
        const parsedPerDiemRate = perDiemRate ? parseFloat(perDiemRate) : 0;
        const parsedCopies = parseFloat(copies) || 0;
        const parsedLodging = parseFloat(lodging) || 0;
        const parsedMisc = parseFloat(misc) || 0;
        const parsedMileageRate = parseFloat(mileageRate) || 0;

        const calculatedPerDiem = calculatePerDiem(
          parsedHours,
          parsedPerDiemRate
        );

        console.log(calculatedPerDiem, "calculatedPerDiemcalculatedPerDiem");
        totalHours += parsedHours;
        totalMiles += parsedMiles;
        totalPerDiem += Number(calculatedPerDiem);
        totalCopies += parsedCopies;
        totalLodging += parsedLodging;
        totalMisc += parsedMisc;
        totalMilege += parsedMileageRate;

        console.log(
          "total hrs",
          Number(calculatedPerDiem),
          totalHours,
          "totalPerDiem",
          totalPerDiem
        );

        const isOfficePerDiem11 =
          (periidemDropDown === "IsOfficePerDiem") ||
          (billingStatementDetailsId === itemId &&
            IsOfficePerDiem === true && IsTravelPerDiem === false && periidemDropDown == "false") ||
          (billingStatementDetailsId === itemId &&
            parsedPerDiemRate !== 0 &&
            !IsTravelPerDiem &&
            periidemDropDown == "false" &&
            IsOfficePerDiem &&
            brokerDetailsVal[0].PayableTravelPerDiem.toString() ==
              parsedPerDiemRate.toString());

        const isTravelPerDiem11 =
          ((periidemDropDown === "IsTravelPerDiem") ||
          ( billingStatementDetailsId === itemId &&
            IsOfficePerDiem === false && 
            IsTravelPerDiem === true && periidemDropDown == "false" ) ||
          (periidemDropDown == "false" && billingStatementDetailsId === itemId &&
            parsedPerDiemRate !== 0 &&
            IsTravelPerDiem &&
            !IsOfficePerDiem && 
            brokerDetailsVal[0].PayableOfficePerDiem.toString() ==
              parsedPerDiemRate.toString()));

        let postData = {
          billingStatementDetailsId: billingStatementDetailsId
            ? billingStatementDetailsId
            : 0,
          headerId: billid,
          billingType: billingType,
          date: date,
          hours: parsedHours,
          perDiemRate: !isNaN(parseFloat(parsedPerDiemRate))
            ? parseFloat(parsedPerDiemRate)
            : 0,
          perDiem: Number(calculatedPerDiem),
          lodging: parsedLodging,
          miles: parsedMiles,
          misc: parsedMisc,
          copies: parsedCopies,
          description: description,
          isOfficePerDiem: isOfficePerDiem11 == true ? true : false,
          isTravelPerDiem: isTravelPerDiem11 == true ? true : false,
        };

        // let postData = {
        //   billingStatementDetailsId: billingStatementDetailsId,
        //   headerId: billid,
        //   billingType: billingType,
        //   date: date,
        //   hours: parsedHours,
        //   perDiemRate: parsedPerDiemRate ? parsedPerDiemRate : 0,
        //   perDiem: calculatedPerDiem,
        //   lodging: parsedLodging,
        //   miles: parsedMiles,
        //   misc: parsedMisc,
        //   copies: parsedCopies,
        //   description: description,
        // };

        postDataArray.push(postData);
        console.log(
          `Lodging: ${lodging}, Billing Type: ${billingType}, Hours: ${hours}, PerDiem: ${parsedPerDiemRate}, Calculated PerDiem: ${calculatedPerDiem}`
        );
      });
    });

    // Update the state after all calculations
    // setBillingStatementDetail((prevState) => ({
    //   ...prevState,
    //   hHours: Number(totalHours).toFixed(2),
    //   hMiles: totalMiles.toString(),
    //   hperdiem: Number(totalPerDiem || 0).toFixed(2), // Ensuring it's a number or 0
    //   hlodging: Number(totalLodging || 0).toFixed(2),
    //   hcopies: totalCopies,
    //   hMilegeRate: Number(totalMilege || 0).toFixed(2),
    //   hmisc: Number(totalMisc || 0).toFixed(2),
    // }));

    console.log("postDataArray", postDataArray);

    let itemIdVal = itemId ? itemId : 0;
    let matchedKey = keyvalue.slice(8);
    let firstData = postDataArray.find(
      (obj) =>
        obj.date === matchedKey && obj.billingStatementDetailsId === itemIdVal
    );

    const {
      hProjectName,
      hCustomerName,
      hbokerName,
      hStatus,
      hHours,
      hCharges,
      hMiles,
      hMilegeRate,
      hperdiem,
      hlodging,
      hcopies,
      hmisc,
      hDayRate,
      hStartDate,
      huserId,
      hperiodKey,
      hprojectID,
      hEndDate,
    } = billingStatementDetail;

    // var totalPerDiemTotal = 0;
    // var expenses = 0;
    // var mileage = 0;
    // var charges = 0;
    // if (totalPerDiem) { totalPerDiemTotal = totalPerDiem; }
    // if (totalLodging || totalCopies || totalMisc) {
    //   if (totalLodging) {
    //     expenses = expenses + totalLodging;
    //   }
    //   if (totalCopies) {
    //     expenses = expenses + totalCopies;
    //   }
    //   if (totalMisc) {
    //     expenses = expenses + totalMisc;
    //   }
    // }
    // if (totalMiles && projectDetailsval[0]?.MileageRate) {
    //   mileage = totalMiles * projectDetailsval[0]?.MileageRate;
    // }
    // if (totalHours && projectDetailsval[0]?.BillingDayRate) {
    //   charges = (totalHours / 8) * projectDetailsval[0]?.BillingDayRate;
    // }
    // const totalValue =
    //   parseFloat(totalPerDiemTotal) +
    //   parseFloat(expenses) +
    //   parseFloat(mileage) +
    //   parseFloat(charges);
    let dayRateUpdated =
      currentBillingStatus == "1" &&
      dayRateMillageRateForBilling.brokerBilling.dayRate != 0
        ? dayRateMillageRateForBilling.brokerBilling.dayRate
        : dayRateMillageRateForBilling.statementBilling.dayRate;

    let millageRateUpdated =
      currentBillingStatus == "1" &&
      dayRateMillageRateForBilling.brokerBilling.millageRate != 0
        ? dayRateMillageRateForBilling.brokerBilling.millageRate
        : dayRateMillageRateForBilling.statementBilling.millageRate;
    {
      console.log("day rate update", dayRateUpdated);
    }

    var charges = 0;
    if (totalHours && dayRateUpdated) {
      charges = (totalHours / 8) * dayRateUpdated;
    }

    // if (totalHours && projectDetailsval[0]?.BillingDayRate) {
    //   charges = (totalHours / 8) * projectDetailsval[0]?.BillingDayRate;
    // }

    const totalValue =
      (totalPerDiem ? parseFloat(totalPerDiem) : 0) +
      (totalLodging ? parseFloat(totalLodging) : 0) +
      (totalCopies ? parseFloat(totalCopies) : 0) +
      (totalMisc ? parseFloat(totalMisc) : 0) +
      (charges ? parseFloat(charges) : 0) +
      (totalMiles ? parseFloat(totalMiles) : 0) *
        (millageRateUpdated ? parseFloat(millageRateUpdated) : 0);

    console.log("totalValuetotalValue One", totalValue);

    let postData = {
      billingStatementId: billid,
      userId: getLogUserId(),
      periodKey: hperiodKey,
      projectId: hprojectID,
      statusId: hStatus == "Statement closed" ? 2 : 1,
      billingStart: hStartDate,
      billingEnd: hEndDate,
      hours: totalHours,
      // dayRate: hDayRate,
      // dayRate: projectDetailsval[0]?.BillingDayRate,
      dayRate: dayRateUpdated,
      perDiem: totalPerDiem,
      lodging: totalLodging,
      miles: totalMiles,
      misc: totalMisc,
      copies: totalCopies,
      // mileageRate: totalMilege,
      // mileageRate: projectDetailsval[0]?.MileageRate,
      mileageRate: millageRateUpdated,
      //total: parseFloat((totalHours / 8) * BillingDayRate).toFixed(2),
      // total: charges.toFixed(2),
      total: totalValue.toFixed(2),
      isOrphaned: 1,
    };

    const updatedData = {
      ...firstData,
      isOrphaned: 1,
      // isTravelPerDiem: periidemDropDown == "IsTravelPerDiem" ? true : false, isOfficePerDiem: periidemDropDown == "IsOfficePerDiem" ? true : false
    };

    // const configone = {
    //   method: "POST",
    //   url: CREATE_UPDATE_BILLING_STATEMENT_URL,
    //   headers: authHeader(),
    //   data: {
    //     webString: enCryptFun(JSON.stringify(postData)),
    //   },
    // };

    const config = {
      method: "POST",
      url: CREATE_UPDATE_BILLING_STATEMENT_DETAILS_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(updatedData)),
      },
    };

    try {
      console.log("config", postDataArray);
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        console.log("updated");
        if (billingStatementDetail.hprojectID) {
          checkBillingProjectDetail(billingStatementDetail.hprojectID);
        }
        getBillStatementDetails(postData);
        setPeridiemDropDown('false')
        // upsertLog("add", firstData?.date);
        // const response1 = await API(configone);
        // let decryptedResponse1 = deCryptFun(response1.data);
        // const parsedResponse1 = JSON.parse(decryptedResponse1);

        // if (parsedResponse1.status == "Success") {
        //   showToast(parsedResponse1.message, "success");
        //   upsertLog("add");
        //   getBillStatementDetails();
        //   getBillingStatement();
        //   setFormSaved(true);
        //   setShowWarning(false);
        //   setWarningHighlightColor(false);
        //   setChangedFields({});
        //   setIsFormDirty(false);
        // }
      }
      setSaveloading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          navigate(ADMIN_BILLING_LIST);
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else {
          showToast(v?.message, "error");
        }
        setSaveloading(false);
      }
    } finally {
      setIsFormUpdate(true);
      setSaveloading(false);
    }
  };

  const calculatePerDiem = (hours, rate) => {
    console.log();
    const parsedRate = parseFloat(rate) || 0;
    const hoursVal = parseFloat(hours) <= 8 ? hours : "8.00";
    const resultCalc = (hoursVal / 8) * parsedRate;

    // Truncate to 2 decimal places without rounding
    const truncatedResult = Math.trunc(resultCalc * 100) / 100;
    const roundedUpResult = Math.round(resultCalc * 100) / 100;
    console.log(roundedUpResult, "roundedUpResultroundedUpResult");
    return roundedUpResult.toFixed(2);
    // const roundedResult = parseFloat(resultCalc.toFixed(3));
    // return roundedResult % 1 === 0
    //   ? roundedResult.toString()
    //   : roundedResult.toFixed(3);
  };

  const upsertBillingFun = async () => {
    console.log("configbill", billingStatementDetail);
    const {
      hProjectName,
      hCustomerName,
      hbokerName,
      hStatus,
      hHours,
      hCharges,
      hMiles,
      hMilegeRate,
      hperdiem,
      hlodging,
      hcopies,
      hmisc,
      hDayRate,
      hStartDate,
      huserId,
      hperiodKey,
      hprojectID,
      hEndDate,
    } = billingStatementDetail;

    const totalValue =
      (hperdiem ? parseFloat(hperdiem) : 0) +
      (hlodging ? parseFloat(hlodging) : 0) +
      (hcopies ? parseFloat(hcopies) : 0) +
      (hmisc ? parseFloat(hmisc) : 0) +
      (hCharges ? parseFloat(hCharges) : 0) +
      (hMiles ? parseFloat(hMiles) : 0) *
        (hMilegeRate ? parseFloat(hMilegeRate) : 0);

    console.log("totalValuetotalValue Two", totalValue);

    let postData = {
      billingStatementId: billid,
      userId: huserId,
      periodKey: hperiodKey,
      projectId: hprojectID,
      statusId: hStatus == "Statement closed" ? 2 : 1,
      billingStart: hStartDate,
      billingEnd: hEndDate,
      hours: hHours,
      dayRate: hDayRate,
      perDiem: hperdiem,
      lodging: hlodging,
      miles: hMiles,
      misc: hmisc,
      copies: hcopies,
      mileageRate: hMilegeRate,
      // total: hCharges,
      total: totalValue.toFixed(2),
    };
    const config = {
      method: "POST",
      url: CREATE_UPDATE_BILLING_STATEMENT_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    try {
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        showToast(parsedResponse.message, parsedResponse.status);
        getBillStatementDetails();
        getBillingStatement();
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          navigate(ADMIN_BILLING_LIST);
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else {
          showToast(v?.message, "error");
        }
      }
    }
  };
  const handleAddItem = async (lineItemKey) => {
    // const newItem = {
    //   date: "",
    //   billingType: "",
    //   hours: "",
    //   description: "",
    //   perDiemRate: "",
    //   misc: "",
    // };

    const currentItems = values[lineItemKey];
    const lastDate = currentItems[currentItems.length - 1].date;
    // showToast(`New line item created for date ${lastDate}.`, "success");

    const newItem = {
      billingType: 0,
      dayRate: "",
      hours: "0.00",
      miles: "0",
      lodging: "0.00",
      description: "",
      perdiemRate: "$0.00",
      perDiem: "0.00",
      copies: "0.00",
      misc: "0",
      date: lastDate,
    };

    let isAddNewDoubleEntry = "Yes";

    const configGetBiilingStatement = {
      method: "GET",
      url: GET_BILLING_STATEMENT_DETAILS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify({ headerId: parseInt(billid) })),
      },
    };

    try {
      const response = await API(configGetBiilingStatement);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        console.log("parsedResponse NEWONEDATA", parsedResponse);

        if (
          parsedResponse &&
          parsedResponse.billingStatementDetails &&
          parsedResponse.billingStatementDetails.length > 0
        ) {
          let billingStatementDetails = parsedResponse.billingStatementDetails;
          // Check if the date matches any date in billingStatementDetails
          const matchFound = billingStatementDetails.some((item) => {
            const itemDate = new Date(item.Date).toISOString().split("T")[0];

            const [month, day, year] = lastDate.split("/");
            var addNewLastDate = `${year}-${month.padStart(
              2,
              "0"
            )}-${day.padStart(2, "0")}`;

            console.log("hi TESTDATAADDEDALREADY", itemDate, addNewLastDate);
            return itemDate === addNewLastDate;
          });

          if (matchFound) {
            isAddNewDoubleEntry = "No";
          }
        }
      }
    } catch (error) {}

    handleAddItemDataInsert(newItem, isAddNewDoubleEntry);
  };

  const handleAddItemDataInsert = async (newItem, isAddNewDoubleEntry) => {
    let insertData = {
      billingStatementDetailsId: 0,
      headerId: billid,
      billingType: 0,
      date: newItem.date,
      hours: 0,
      perDiemRate: 0,
      perDiem: 0,
      lodging: 0,
      miles: 0,
      misc: 0,
      copies: 0,
      description: "",
      isOrphaned: 1,
      IsOfficePerDiem: false,
      IsTravelPerDiem: false,
    };

    if (isAddNewDoubleEntry === "Yes") {
      await postData(insertData);
      // await postData(insertData); // Insert twice if the condition is 'Yes'
    } else {
      await postData(insertData); // Insert once otherwise
    }
  };

  // Create a function to handle the POST request
  const postData = async (data) => {
    const config = {
      method: "POST",
      url: CREATE_UPDATE_BILLING_STATEMENT_DETAILS_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      setValues((prevValues) => ({
        ...prevValues,
        [lineItemKey]: [
          ...prevValues[lineItemKey],
          {
            billingType: 0,
            dayRate: "",
            hours: "0.00",
            miles: "0",
            lodging: "0.00",
            description: "",
            perdiemRate: "$0.00",
            perDiem: "0.00",
            copies: "0.00",
            misc: "0",
            date: lastDate,
          },
        ],
      }));

      setFieldValue(lineItemKey, [...values[lineItemKey], newItem]);
      setFormSaved(true);
      setShowWarning(false);
      setWarningHighlightColor(false);
      setChangedFields({});
      setIsFormDirty(false);
      setIsNewitemAdded(true);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              projectId: "",
              userId: "",
              filterValues: {},
            },
          });
          navigate(BILLING_STATEMENT_LIST_ROUTE);
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else {
          showToast(v?.message, "error");
        }
      }
    } finally {
      setIsFormUpdate(true);
    }
  };

  const removeItemFuncConfirm = (value) => {
    if (value === true) {
      handleDeleteItem(itemRemoveConfirmItem.key, itemRemoveConfirmItem.index);
    }
    setItemRemoveConfirmStatus(false);
    setItemRemoveConfirmItem("");
  };

  const handleDeleteItem = (lineItemKey, index) => {
    const currentItems = values[lineItemKey];
    const itemToDelete = currentItems[index];
    const newItems = values[lineItemKey].filter((_, i) => i !== index);
    setFieldValue(lineItemKey, newItems);

    // Check if the item has values
    const hasValues = Object.values(itemToDelete).some((value) => value !== "");

    if (hasValues) {
      if (itemToDelete.billingStatementDetailsId) {
        // Call the API to delete the item
        deleteLineItemFromAPI(itemToDelete, lineItemKey);
      } else {
        // Remove the item from the state
        setValues((prevValues) => ({
          ...prevValues,
          [lineItemKey]: prevValues[lineItemKey].filter((_, i) => i !== index),
        }));

        showToast(`Line item removed for date ${itemToDelete.date}.`, "error");
      }
    } else {
      // Remove the item from the state
      setValues((prevValues) => ({
        ...prevValues,
        [lineItemKey]: prevValues[lineItemKey].filter((_, i) => i !== index),
      }));
      showToast(`Line item removed for date ${itemToDelete.date}.`, "error");
    }
    // setIsFormUpdate(true);
  };

  // Example API call function
  const deleteLineItemFromAPI = async (item, lineItemKey) => {
    console.log("deleteLineItemFromAPI item", item);
    console.log("deleteLineItemFromAPI lineItemKey", lineItemKey);
    console.log("deleteLineItemFromAPI values", values);
    console.log("deleteLineItemFromAPI Start.", values);

    let data = {
      billingStatementDetailsId: parseInt(item.billingStatementDetailsId),
      isOrphaned: 1,
    };
    const config = {
      method: "DELETE",
      url: DELETE_BILLING_STATEMENT_BY_ID,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      console.log("config", data);
      const response = await API(config);

      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        // setValues((prevValues) => ({
        //   ...prevValues,
        //   [lineItemKey]: prevValues[lineItemKey].filter((_, i) => i !== index),
        // }));

        var lineItemArray = values[lineItemKey];
        var indexToRemove = lineItemArray.findIndex(
          (itemBilling) =>
            itemBilling.billingStatementDetailsId ===
            item.billingStatementDetailsId
        );
        if (indexToRemove !== -1) {
          lineItemArray.splice(indexToRemove, 1);
        }
        getBillStatementDetails("", "Delete");
        if (billingStatementDetail?.hprojectID) {
          checkBillingProjectDetail(billingStatementDetail?.hprojectID);
        }
        // upsertBillingDetailsFunForDelete(values);

        //  await upsertBillingDetailsFunForDelete(values);
        //getBillStatementDetails();
        upsertLog("remove", item?.date);

        showToast(`Line item removed for date '${item.date}'`, "error");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          navigate(ADMIN_BILLING_LIST);
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else {
          showToast(v?.message, "error");
        }
      }
    }
  };

  const upsertBillingDetailsFunForDelete = async (values) => {
    let totalHours = 0;
    let totalMiles = 0;
    let totalPerDiem = 0;
    let totalCopies = 0;
    let totalLodging = 0;
    let totalMisc = 0;
    let totalMilege = 0;

    const myResponseLookup =
      values &&
      values.reduce((acc, item) => {
        const formattedDate = moment(item.Date).utc().format("MM/DD/YYYY");
        if (!acc[`lineItem${formattedDate}`]) {
          acc[`lineItem${formattedDate}`] = [];
        }
        acc[`lineItem${formattedDate}`].push(item);
        return acc;
      }, {});

    console.log(myResponseLookup, "myResponseLookupmyResponseLookup");
    console.log(values, "valiueuuuuuuu");

    Object.keys(myResponseLookup).forEach((key) => {
      myResponseLookup[key].forEach((item) => {
        const {
          Lodging,
          BillingType,
          Hours,
          PerDiem,
          dayRate,
          Miles,
          Misc,
          Copies,
          mileageRate,
          total,
          Date,
          PerDiemRate,
          Description,
          billingStatementDetailsId,
        } = item;

        // Only process items where billingStatementDetailsId is not empty
        console.log("inside item", item);

        console.log(
          parseFloat(PerDiemRate),
          "parseFloat(PerDiemRate)",
          parseInt(PerDiemRate),
          PerDiemRate
        );

        // Ensure values are parsed as numbers
        const parsedHours = parseFloat(Hours) || 0;
        const parsedMiles = parseFloat(Miles) || 0;
        const parsedPerDiemRate = PerDiemRate ? parseFloat(PerDiemRate) : 0;
        const parsedCopies = parseFloat(Copies) || 0;
        const parsedLodging = parseFloat(Lodging) || 0;
        const parsedMisc = parseFloat(Misc) || 0;
        const parsedMileageRate = parseFloat(MileageRate) || 0;

        const calculatedPerDiem = calculatePerDiem(
          parsedHours,
          parsedPerDiemRate
        );

        console.log(calculatedPerDiem, "akljslkhaskd");

        totalHours += parsedHours;
        totalMiles += parsedMiles;
        totalPerDiem += Number(calculatedPerDiem) || 0;
        totalCopies += parsedCopies;
        totalLodging += parsedLodging;
        totalMisc += parsedMisc;
        totalMilege += parsedMileageRate;
      });
    });

    // Update the state after all calculations
    // setBillingStatementDetail((prevState) => ({
    //   ...prevState,
    //   hHours: Number(totalHours).toFixed(2),
    //   hMiles: totalMiles.toString(),
    //   hperdiem: Number(totalPerDiem || 0).toFixed(2), // Ensuring it's a number or 0
    //   hlodging: Number(totalLodging || 0).toFixed(2),
    //   hcopies: totalCopies,
    //   hMilegeRate: Number(totalMilege || 0).toFixed(2),
    //   hmisc: Number(totalMisc || 0).toFixed(2),
    // }));

    const {
      hProjectName,
      hCustomerName,
      hbokerName,
      hStatus,
      hHours,
      hCharges,
      hMiles,
      hMilegeRate,
      hperdiem,
      hlodging,
      hcopies,
      hmisc,
      hDayRate,
      hStartDate,
      huserId,
      hperiodKey,
      hprojectID,
      hEndDate,
    } = billingStatementDetail;

    let dayRateUpdated =
      currentBillingStatus == "1" &&
      dayRateMillageRateForBilling.brokerBilling.dayRate != 0
        ? dayRateMillageRateForBilling.brokerBilling.dayRate
        : dayRateMillageRateForBilling.statementBilling.dayRate;

    let millageRateUpdated =
      currentBillingStatus == "1" &&
      dayRateMillageRateForBilling.brokerBilling.millageRate != 0
        ? dayRateMillageRateForBilling.brokerBilling.millageRate
        : dayRateMillageRateForBilling.statementBilling.millageRate;

    var charges = 0;
    if (totalHours && dayRateUpdated) {
      charges = (totalHours / 8) * dayRateUpdated;
    }

    const totalValue =
      (totalPerDiem ? parseFloat(totalPerDiem) : 0) +
      (totalLodging ? parseFloat(totalLodging) : 0) +
      (totalCopies ? parseFloat(totalCopies) : 0) +
      (totalMisc ? parseFloat(totalMisc) : 0) +
      (charges ? parseFloat(charges) : 0) +
      (totalMiles ? parseFloat(totalMiles) : 0) *
        (millageRateUpdated ? parseFloat(millageRateUpdated) : 0);

    console.log(totalPerDiem, "totalValuetotalValue Three", totalValue);

    let postData = {
      billingStatementId: billid,
      userId: getLogUserId(),
      periodKey: hperiodKey,
      projectId: hprojectID,
      statusId: hStatus == "Statement closed" ? 2 : 1,
      billingStart: hStartDate,
      billingEnd: hEndDate,
      hours: totalHours?.toFixed(2),
      // dayRate: hDayRate,
      // dayRate: projectDetailsval[0]?.BillingDayRate,
      dayRate: dayRateUpdated,
      perDiem: totalPerDiem.toFixed(2),
      lodging: totalLodging?.toFixed(2),
      miles: totalMiles,
      misc: totalMisc?.toFixed(2),
      copies: totalCopies,
      // mileageRate: totalMilege,
      // mileageRate: projectDetailsval[0]?.MileageRate,
      mileageRate: millageRateUpdated,
      //total: parseFloat((totalHours / 8) * BillingDayRate).toFixed(2),
      // total: charges.toFixed(2),
      total: totalValue.toFixed(2),
    };

    const config = {
      method: "POST",
      url: CREATE_UPDATE_BILLING_STATEMENT_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };

    try {
      const response = await API(config);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          navigate(ADMIN_BILLING_LIST);
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else {
          showToast(v?.message, "error");
        }
      }
    } finally {
      setIsFormUpdate(true);
    }
  };

  const calculateDate = (index) => {
    return moment().add(index, "days").format("MM/DD/YYYY");
  };
  const validateLineItemOld = async (key, index) => {
    const lineItemPath = `${key}[${index}]`;
    const lineItemValues = values[key][index];

    try {
      await lineItemValidationSchema.validate(lineItemValues, {
        abortEarly: false,
      });
      const newErrors = { ...errors };
      if (newErrors[key]) {
        newErrors[key].splice(index, 1);
        if (newErrors[key].length === 0) {
          delete newErrors[key];
        }
      }
      setErrors(newErrors);
      return true;
    } catch (validationErrors) {
      if (validationErrors.inner) {
        const newErrors = { ...errors };
        if (!newErrors[key]) {
          newErrors[key] = [];
        }
        newErrors[key][index] = validationErrors.inner.reduce((acc, error) => {
          acc[error.path.split(".").pop()] = error.message;
          return acc;
        }, {});
        setErrors(newErrors);

        // Mark fields as touched
        const newTouched = { ...touched };
        if (!newTouched[key]) {
          newTouched[key] = [];
        }
        newTouched[key][index] = validationErrors.inner.reduce((acc, error) => {
          acc[error.path.split(".").pop()] = true;
          return acc;
        }, {});
        setTouched(newTouched);
      }
      return false;
    }
  };

  const validateLineItem = async (key, index) => {
    const lineItemValues = values[key][index];

    var errorArray = [];

    if (!lineItemValues.billingType) {
      errorArray.push(`No Billing Type selected for '${lineItemValues.date}'`);
    }

    // if(parseFloat(lineItemValues.miles) <= 0) {
    //   errorArray.push("Day Rate is required")
    // }

    // if (parseFloat(lineItemValues.hours) <= 0) {
    //   errorArray.push("Hours is required");
    // }

    // if (parseFloat(lineItemValues.miles) <= 0) {
    //   errorArray.push("Miles is required");
    // }

    // if (!lineItemValues.description) {
    //   errorArray.push("Description is required");
    // }

    // if (
    //   !lineItemValues.perDiemRate ||
    //   parseFloat(lineItemValues.perDiemRate) <= 0
    // ) {
    //   errorArray.push("PerDiem Rate is required");
    // }

    // if (parseFloat(lineItemValues.misc) <= 0) {
    //   errorArray.push("Misc is required");
    // }

    // if (parseFloat(lineItemValues.copies) < 0) {
    //   errorArray.push("Copies is required");
    // }

    return errorArray;
  };

  const handleSaveItem = async (key, index, itemid) => {
    console.log("New item KEY -->", key);
    console.log("New item index -->", index);
    console.log("New item itemid -->", itemid);
    console.log("New item values -->", values);

    const isValidErrorArray = await validateLineItem(key, index);
    if (isValidErrorArray && isValidErrorArray.length > 0) {
      showToast(isValidErrorArray[0], "error");
      //showToast(isValidErrorArray, "groupError"); // For Group Msg

      // for (let error of isValidErrorArray) {
      //   showToast(error, "error");
      // }
    } else {
      console.log("Line item is valid, proceeding with submission");
      upsertBillingDetailsFun(values, key, itemid);
      if (billingStatementDetail?.hprojectID) {
        checkBillingProjectDetail(billingStatementDetail?.hprojectID);
      }
      setFormSaved(true);
      setShowWarning(false);
      setWarningHighlightColor(false);
      setChangedFields({});
      setIsFormDirty(false); // Uncomment this if you want to submit the form
    }
  };

  //  const handleSaveItem = async (key, index) => {
  //    const fieldPrefix = `${key}[${index}]`;

  //    // Validate all fields in the specific line item
  //    const fields = Object.keys(values[key][index]);
  //    const isValid = await Promise.all(
  //      fields.map(async (field) => {
  //        const fieldName = `${fieldPrefix}.${field}`;
  //        try {
  //          await validateField(fieldName);
  //          return true;
  //        } catch (error) {
  //          setFieldTouched(fieldName, true);
  //          return false;
  //        }
  //      })
  //    );

  //    // If all fields are valid, proceed with submission logic
  //    if (isValid.every(Boolean)) {
  //      handleSubmit();
  //    }
  //  };
  const updateBillingStatus = async (id, status, val, type) => {
    // setCurrentBillingStatus(status);
    let data = {
      billingId: id,
      statusId: status,
      isOrphaned: 1,
    };
    const config = {
      method: "PUT",
      url: UPDATE_BILLING_STATUS_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        if (val === "reopenBilling") {
          showToast(
            `Billing statement (${billingStatementDetail.hStartDate} - ${billingStatementDetail.hEndDate}) was reopened in project '${billingStatementDetail.hProjectName}' for customer '${billingStatementDetail.hCustomerName}.'`,
            "success"
          );
          await checkBillingProjectDetail(
            billingStatementDetail?.hprojectID,
            "reopenBilling"
          );
        } else if (val === "closeBilling") {
          showToast(
            `Billing statement (${billingStatementDetail.hStartDate} - ${billingStatementDetail.hEndDate}) was closed in project '${billingStatementDetail.hProjectName}' for customer '${billingStatementDetail.hCustomerName}.'`,
            "success"
          );
          if (status == 2) {
            showToast(
              "Statement is closed and must be reopened to edit. This statement has not yet been invoiced so you may still reopen it for edit.",
              "reopenBilling"
            );
          }
        }
        if (status == 2 && type != "No_Need_Api_Close_Invoice") {
          let dayRateUpdated =
            currentBillingStatus == "1" &&
            dayRateMillageRateForBilling.brokerBilling.dayRate != ""
              ? dayRateMillageRateForBilling.brokerBilling.dayRate
              : dayRateMillageRateForBilling.statementBilling.dayRate;

          let millageRateUpdated =
            currentBillingStatus == "1" &&
            dayRateMillageRateForBilling.brokerBilling.millageRate != ""
              ? dayRateMillageRateForBilling.brokerBilling.millageRate
              : dayRateMillageRateForBilling.statementBilling.millageRate;

          const totalValue =
            (billingStatementDetail.hperdiem
              ? parseFloat(billingStatementDetail.hperdiem)
              : 0) +
            (billingStatementDetail.hlodging
              ? parseFloat(billingStatementDetail.hlodging)
              : 0) +
            (billingStatementDetail.hcopies
              ? parseFloat(billingStatementDetail.hcopies)
              : 0) +
            (billingStatementDetail.hmisc
              ? parseFloat(billingStatementDetail.hmisc)
              : 0) +
            (billingStatementDetail.hCharges
              ? parseFloat(billingStatementDetail.hCharges)
              : 0) +
            (billingStatementDetail.hMiles
              ? parseFloat(billingStatementDetail.hMiles)
              : 0) *
              (millageRateUpdated ? parseFloat(millageRateUpdated) : 0);

          console.log("totalValuetotalValue Four", totalValue);

          let postData = {
            billingStatementId: billid,
            userId: getLogUserId(),
            periodKey: billingStatementDetail.hperiodKey,
            projectId: billingStatementDetail.hprojectID,
            statusId: status,
            billingStart: billingStatementDetail.hStartDate,
            billingEnd: billingStatementDetail.hEndDate,
            hours: billingStatementDetail.hHours,
            dayRate: dayRateUpdated,
            perDiem: billingStatementDetail.hperdiem,
            lodging: billingStatementDetail.hlodging,
            miles: billingStatementDetail.hMiles,
            misc: billingStatementDetail.hmisc,
            copies: billingStatementDetail.hcopies,
            mileageRate: millageRateUpdated,
            // total: billingStatementDetail.hCharges,
            total: totalValue.toFixed(2),
          };
          const configone = {
            method: "POST",
            url: CREATE_UPDATE_BILLING_STATEMENT_URL,
            headers: authHeader(),
            data: {
              webString: enCryptFun(JSON.stringify(postData)),
            },
          };
          try {
            await API(configone);
          } catch (error) {}

          setDayRateMillageRateForBilling((prevState) => ({
            ...prevState,
            statementBilling: {
              ...prevState.statementBilling,
              dayRate: dayRateUpdated,
              millageRate: millageRateUpdated,
            },
          }));

          setActiveStep(1);
          setCloseStatementButton(true);
          const newCompleted = completed;
          newCompleted[activeStep] = true;
          setCompleted(newCompleted);
          // setActiveStep(1);
          setBillingStatus(true);
          setDAyPrev(brokerDetailsVal[0].DayRate);
          setMileagePrev(MileageRate);
        } else if (status == 1) {
          setActiveStep(0);
          setBillingStatus(false);
        }
        getBillingStatement();
        getBillStatementDetails();
        setCloseStatementButton(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              projectId: "",
              userId: "",
              filterValues: {},
            },
          });
          navigate(ADMIN_BILLING_LIST);
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else if (
          v.message ==
          "This billing statement has started the invoice process and cannot be reopened"
        ) {
          showToast(
            "This billing statement has started the invoice process and cannot be reopened",
            "error"
          );
          if (status == 3) {
            showToast(
              "Statement is closed and cannot be reopoened because it is attached to an open invoice. To edit this statement you must ask an administrator to detatach it from the invoice. Then the statement can be reopened and will be eligible for edit.",
              "reopenBilling"
            );
          }
          getBillingStatement();
          getBillStatementDetails();
          setActiveStep(2);
        } else if (status == 2) {
          setActiveStep(0);
          setCloseStatementButton(true);
          const newCompleted = completed;
          newCompleted[activeStep] = true;
          setCompleted(newCompleted);
          // setActiveStep(1);
          setBillingStatus(true);
          setDAyPrev(brokerDetailsVal[0]?.DayRate);
          setMileagePrev(MileageRate);
          setBillingStatus(false);
          navigate(ADMIN_BILLING_LIST);
        } else if (status == 1) {
          setActiveStep(1);
        } else if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          navigate(ADMIN_BILLING_LIST);
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else {
          showToast(v?.message, "error");
        }
      }
      setCloseStatementButton(false);
    } finally {
      setIsFormUpdate(true);
    }
  };
  // const handleBillingStatus = (val) => {
  //   console.log(val, "valurbshakkkakjhajh");
  //   if (!formSaved) {
  //     setShowWarning(true);
  //     setCloseBillingAlert(true);
  //   } else {
  //     setDayRateMillageRateForBilling((prevState) => ({
  //       ...prevState,
  //       statementBilling: {
  //         ...prevState.statementBilling,
  //         dayRate: prevState.brokerBilling?.dayRate,
  //         millageRate: prevState.brokerBilling?.millageRate,
  //       },
  //     }));
  //     localStorage.setItem(
  //       "DAYSTATEMENT",
  //       dayRateMillageRateForBilling?.brokerBilling?.dayRate
  //     );
  //     const millageRate = parseFloat(dayRateMillageRateForBilling?.brokerBilling?.millageRate) || 0;
  //     console.log("millageRate before storing:", millageRate);
  //     localStorage.setItem("MILSTATEMENT", millageRate.toFixed(2));

  //     // setCloseStatementButton(true);
  //     // const newCompleted = completed;
  //     // newCompleted[activeStep] = true;
  //     // setCompleted(newCompleted);
  //     // // setActiveStep(1);
  //     // setBillingStatus(true);
  //     // setDAyPrev(brokerDetailsVal[0].DayRate);
  //     // setMileagePrev(MileageRate);
  //     updateBillingStatus(billid, 2, val);
  //   }
  // };

  const handleBillingStatus = async (val) => {
    // let dayRateUpdated =
    //   currentBillingStatus == "1" &&
    //   dayRateMillageRateForBilling.brokerBilling.dayRate != 0
    //     ? dayRateMillageRateForBilling.brokerBilling.dayRate
    //     : dayRateMillageRateForBilling.statementBilling.dayRate;

    // let millageRateUpdated =
    //   currentBillingStatus == "1" &&
    //   dayRateMillageRateForBilling.brokerBilling.millageRate != 0
    //     ? dayRateMillageRateForBilling.brokerBilling.millageRate
    //     : dayRateMillageRateForBilling.statementBilling.millageRate;

    // const totalValue =
    //   (billingStatementDetail.hperdiem
    //     ? parseFloat(billingStatementDetail.hperdiem)
    //     : 0) +
    //   (billingStatementDetail.hlodging
    //     ? parseFloat(billingStatementDetail.hlodging)
    //     : 0) +
    //   (billingStatementDetail.hcopies
    //     ? parseFloat(billingStatementDetail.hcopies)
    //     : 0) +
    //   (billingStatementDetail.hmisc
    //     ? parseFloat(billingStatementDetail.hmisc)
    //     : 0) +
    //   (billingStatementDetail.hCharges
    //     ? parseFloat(billingStatementDetail.hCharges)
    //     : 0) +
    //   (billingStatementDetail.hMiles
    //     ? parseFloat(billingStatementDetail.hMiles)
    //     : 0) *
    //     (millageRateUpdated ? parseFloat(millageRateUpdated) : 0);

    let dayRateUpdated =
      currentBillingStatus == "1" &&
      dayRateMillageRateForBilling.brokerBilling.dayRate != 0
        ? dayRateMillageRateForBilling.brokerBilling.dayRate
        : dayRateMillageRateForBilling.statementBilling.dayRate;

    let millageRateUpdated =
      currentBillingStatus == "1" &&
      dayRateMillageRateForBilling.brokerBilling.millageRate != 0
        ? dayRateMillageRateForBilling.brokerBilling.millageRate
        : dayRateMillageRateForBilling.statementBilling.millageRate;

    var charges = 0;
    if (billingStatementDetail.hHours && dayRateUpdated) {
      charges = (billingStatementDetail.hHours / 8) * dayRateUpdated;
    }

    const totalValue =
      (billingStatementDetail.hperdiem
        ? parseFloat(billingStatementDetail.hperdiem)
        : 0) +
      (billingStatementDetail.hlodging
        ? parseFloat(billingStatementDetail.hlodging)
        : 0) +
      (billingStatementDetail.hcopies
        ? parseFloat(billingStatementDetail.hcopies)
        : 0) +
      (billingStatementDetail.hmisc
        ? parseFloat(billingStatementDetail.hmisc)
        : 0) +
      (charges ? parseFloat(charges) : 0) +
      (billingStatementDetail.hMiles
        ? parseFloat(billingStatementDetail.hMiles)
        : 0) *
        (millageRateUpdated ? parseFloat(millageRateUpdated) : 0);

    let postData = {
      billingStatementId: billid,
      userId: getLogUserId(),
      periodKey: billingStatementDetail.hperiodKey,
      projectId: billingStatementDetail.hprojectID,
      statusId: status,
      billingStart: billingStatementDetail.hStartDate,
      billingEnd: billingStatementDetail.hEndDate,
      hours: billingStatementDetail.hHours,
      dayRate: dayRateUpdated,
      perDiem: billingStatementDetail.hperdiem,
      lodging: billingStatementDetail.hlodging,
      miles: billingStatementDetail.hMiles,
      misc: billingStatementDetail.hmisc,
      copies: billingStatementDetail.hcopies,
      mileageRate: millageRateUpdated,
      total: totalValue.toFixed(2),
    };

    console.log("totalValuetotalValue seven", totalValue, postData);

    console.log(val, "valurbshakkkakjhajh");
    if (!formSaved) {
      setShowWarning(true);
      setCloseBillingAlert(true);
      setCloseInvoiceDetails(postData);
    } else {
      setLoading(true);
      await checkBillingProjectDetail(
        billingStatementDetail?.hprojectID,
        "Closed_Invoice"
      );
      // updateHeaderDetails(postData, billid, 2, val, "No_Need_Api_Close_Invoice")
      // setDayRateMillageRateForBilling((prevState) => ({
      //   ...prevState,
      //   statementBilling: {
      //     ...prevState.statementBilling,
      //     dayRate: prevState.brokerBilling?.dayRate,
      //     millageRate: prevState.brokerBilling?.millageRate,
      //   },
      // }));
      // localStorage.setItem(
      //   "DAYSTATEMENT",
      //   dayRateMillageRateForBilling?.brokerBilling?.dayRate
      // );
      // localStorage.setItem(
      //   "MILSTATEMENT",
      //   dayRateMillageRateForBilling?.brokerBilling?.millageRate
      // );
      // setCloseStatementButton(true);
      // const newCompleted = completed;
      // newCompleted[activeStep] = true;
      // setCompleted(newCompleted);
      // // setActiveStep(1);
      // setBillingStatus(true);
      // setDAyPrev(brokerDetailsVal[0].DayRate);
      // setMileagePrev(MileageRate);
      // updateBillingStatus(billid, 2, val, "No_Need_Api_Close_Invoice");
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  console.log(getLogUserId(), "jshajjas", getLogUserRole());
  const checkBillingProjectDetail = async (ProjectID, type) => {
    setSaveloading(true);
    let data = {
      projectId: ProjectID,
    };
    const config = {
      method: "GET",
      url: GET_PROJECT_DETAILS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        const { BrokerDetails, ProjectDetails } = parsedResponse;
        console.log(BrokerDetails, "jdhjkahdkjhfs", orphanedBillingDetail);
        const newvalBroker = BrokerDetails.filter((item) => {
          return item?.UserID === orphanedBillingDetail[0]?.UserID;
        });
        console.log("new broker get from", newvalBroker, currentBillingStatus);
        if (newvalBroker && newvalBroker[0]) {
          let dayRateUpdatedVal =
            currentBillingStatus == "1" &&
            dayRateMillageRateForBilling.brokerBilling.dayRate != ""
              ? dayRateMillageRateForBilling.brokerBilling.dayRate
              : dayRateMillageRateForBilling.statementBilling.dayRate;
          let millageRateUpdated =
            currentBillingStatus == "1" &&
            dayRateMillageRateForBilling.brokerBilling.millageRate != 0
              ? dayRateMillageRateForBilling.brokerBilling.millageRate
              : dayRateMillageRateForBilling.statementBilling.millageRate;

          console.log(
            dayRateMillageRateForBilling,
            "boooooorokerDetailsValbrokerDetailsVal"
          ); //BillableOfficePerDiem
          console.log("what type", type);
          if (type == "Closed_Invoice") {
            // const totalValue =
            //   (billingStatementDetail.hperdiem
            //     ? parseFloat(billingStatementDetail.hperdiem)
            //     : 0) +
            //   (billingStatementDetail.hlodging
            //     ? parseFloat(billingStatementDetail.hlodging)
            //     : 0) +
            //   (billingStatementDetail.hcopies
            //     ? parseFloat(billingStatementDetail.hcopies)
            //     : 0) +
            //   (billingStatementDetail.hmisc
            //     ? parseFloat(billingStatementDetail.hmisc)
            //     : 0) +
            //   (billingStatementDetail.hCharges
            //     ? parseFloat(billingStatementDetail.hCharges)
            //     : 0) +
            //   (billingStatementDetail.hMiles
            //     ? parseFloat(billingStatementDetail.hMiles)
            //     : 0) *
            //     (millageRateUpdated ? parseFloat(millageRateUpdated) : 0);
            console.log(
              currentBillingStatus,
              "currentBillingStatuscurrentBillingStatus"
            );
            let dayRateUpdated =
              currentBillingStatus == "1" && newvalBroker[0]?.DayRate != ""
                ? newvalBroker[0]?.DayRate
                : dayRateMillageRateForBilling.statementBilling.dayRate;

            let millageRateUpdated =
              currentBillingStatus == "1" && ProjectDetails[0].MileageRate != ""
                ? ProjectDetails[0].MileageRate
                : dayRateMillageRateForBilling.statementBilling.millageRate;

            var charges = 0;
            if (
              billingStatementDetail.hHours &&
              (newvalBroker[0]?.DayRate || dayRateUpdated)
            ) {
              charges =
                (billingStatementDetail.hHours / 8) *
                (newvalBroker[0]?.DayRate !== undefined &&
                newvalBroker[0]?.DayRate !== null
                  ? newvalBroker[0]?.DayRate
                  : dayRateUpdated);
            }
            localStorage.setItem("DAYSTATEMENT", newvalBroker[0]?.DayRate);
            localStorage.setItem(
              "MILSTATEMENT",
              ProjectDetails[0]?.MileageRate
            );
            const totalValue =
              (billingStatementDetail.hperdiem
                ? parseFloat(
                    parseFloat(billingStatementDetail.hperdiem).toFixed(2)
                  )
                : 0) +
              (billingStatementDetail.hlodging
                ? parseFloat(
                    parseFloat(billingStatementDetail.hlodging).toFixed(2)
                  )
                : 0) +
              (billingStatementDetail.hcopies
                ? parseFloat(
                    parseFloat(billingStatementDetail.hcopies).toFixed(2)
                  )
                : 0) +
              (billingStatementDetail.hmisc
                ? parseFloat(
                    parseFloat(billingStatementDetail.hmisc).toFixed(2)
                  )
                : 0) +
              (charges ? parseFloat(parseFloat(charges).toFixed(2)) : 0) +
              (billingStatementDetail.hMiles
                ? parseFloat(
                    parseFloat(billingStatementDetail.hMiles).toFixed(2)
                  )
                : 0) *
                (millageRateUpdated
                  ? parseFloat(parseFloat(millageRateUpdated).toFixed(2))
                  : 0);

            console.log(
              "perDiem:",
              parseFloat(billingStatementDetail.hperdiem),
              "lodg:",
              parseFloat(billingStatementDetail.hlodging),
              "cope:",
              billingStatementDetail.hcopies
                ? parseFloat(billingStatementDetail.hcopies)
                : 0,
              "misc:",
              billingStatementDetail.hmisc
                ? parseFloat(billingStatementDetail.hmisc)
                : 0,
              "charge:",
              charges ? parseFloat(charges) : 0,
              "mile:",
              (billingStatementDetail.hMiles
                ? parseFloat(billingStatementDetail.hMiles)
                : 0) *
                (millageRateUpdated ? parseFloat(millageRateUpdated) : 0),
              "total:",
              totalValue
            );

            let postData = {
              billingStatementId: billid,
              userId: getLogUserId(),
              periodKey: billingStatementDetail.hperiodKey,
              projectId: billingStatementDetail.hprojectID,
              statusId: 2,
              billingStart: billingStatementDetail.hStartDate,
              billingEnd: billingStatementDetail.hEndDate,
              hours: billingStatementDetail.hHours,
              dayRate: newvalBroker[0].DayRate,
              perDiem: billingStatementDetail.hperdiem,
              lodging: billingStatementDetail.hlodging,
              miles: billingStatementDetail.hMiles,
              misc: billingStatementDetail.hmisc,
              copies: billingStatementDetail.hcopies,
              mileageRate: ProjectDetails[0].MileageRate,
              total: totalValue.toFixed(2),
            };

            console.log(totalValue, "totattttt");

            if (
              newvalBroker[0].DayRate != dayRateUpdatedVal ||
              ProjectDetails[0].MileageRate != millageRateUpdated
            ) {
              showToast(
                `There are descripencies in the broker's payables, and the new payable is applied.`,
                "dayRateWarining"
              );
            }
            setDayRateMillageRateForBilling((prevState) => ({
              ...prevState,
              brokerBilling: {
                ...prevState.brokerBilling,
                dayRate: newvalBroker[0].DayRate,
                millageRate:
                  ProjectDetails &&
                  ProjectDetails[0] &&
                  ProjectDetails[0].MileageRate,
              },
            }));
            console.log("totalValuetotalValue six", totalValue);

            if (type === "Closed_Invoice") {
              updateHeaderDetails(
                postData,
                billid,
                2,
                "closeBilling",
                "No_Need_Api_Close_Invoice"
              );
            }
            console.log(
              ProjectDetails[0].MileageRate,
              "ProjectDetails[0].MileageRate != millageRateUpdated",
              millageRateUpdated
            );
          } else if (
            newvalBroker[0].DayRate != dayRateUpdatedVal ||
            ProjectDetails[0].MileageRate != millageRateUpdated
          ) {
            const totalValue =
              (billingStatementDetail.hperdiem
                ? parseFloat(billingStatementDetail.hperdiem)
                : 0) +
              (billingStatementDetail.hlodging
                ? parseFloat(billingStatementDetail.hlodging)
                : 0) +
              (billingStatementDetail.hcopies
                ? parseFloat(billingStatementDetail.hcopies)
                : 0) +
              (billingStatementDetail.hmisc
                ? parseFloat(billingStatementDetail.hmisc)
                : 0) +
              (billingStatementDetail.hCharges
                ? parseFloat(billingStatementDetail.hCharges)
                : 0) +
              (billingStatementDetail.hMiles && millageRateUpdated
                ? parseFloat(billingStatementDetail.hMiles) *
                  parseFloat(millageRateUpdated)
                : 0);

            console.log("update with currwnt", totalValue, dayRateUpdatedVal);
            let postData = {
              billingStatementId: billid,
              userId: getLogUserId(),
              periodKey: billingStatementDetail.hperiodKey,
              projectId: billingStatementDetail.hprojectID,
              statusId: 2,
              billingStart: billingStatementDetail.hStartDate,
              billingEnd: billingStatementDetail.hEndDate,
              hours: billingStatementDetail.hHours,
              dayRate: newvalBroker[0].DayRate,
              perDiem: billingStatementDetail.hperdiem,
              lodging: billingStatementDetail.hlodging,
              miles: billingStatementDetail.hMiles,
              misc: billingStatementDetail.hmisc,
              copies: billingStatementDetail.hcopies,
              mileageRate: ProjectDetails[0].MileageRate,
              total: totalValue.toFixed(2),
            };

            console.log("totalValuetotalValue five", totalValue, postData);

            if (type === "Closed_Invoice") {
              updateHeaderDetails(
                postData,
                billid,
                2,
                "closeBilling",
                "No_Need_Api_Close_Invoice"
              );
            }

            showToast(
              `There are descripencies in the broker's payables, and the new payable is applied.`,
              "dayRateWarining"
            );
            console.log("totalValuetotalValue now", totalValue, postData);

            setDayRateMillageRateForBilling((prevState) => ({
              ...prevState,
              brokerBilling: {
                ...prevState.brokerBilling,
                dayRate: newvalBroker[0].DayRate,
                millageRate:
                  ProjectDetails &&
                  ProjectDetails[0] &&
                  ProjectDetails[0].MileageRate,
              },
            }));
          }
        }
        setSaveloading(false);
        console.log(newvalBroker, "newvalBroker");
      }
    } catch (error) {
      setSaveloading(false);
    }
    setSaveloading(false);
  };

  const reopenBillFun = (val) => {
    showToast(
      "You are not authorized to access the closed billing statements.",
      "error"
    );
    // setBillingStatus(false);
    // setActiveStep(0);
    // updateBillingStatus(billid, 1, val);
  };
  const handleCannotOpen = (val) => {
    // showToast(
    //   "A billing statement already exists for this project during this billing period.",
    //   "error"
    // );
    showToast(
      "This billing statement has started the invoice process and cannot be reopened",
      "error"
    );
    if (activeStep == 2) {
      showToast(
        "Statement is closed and cannot be reopoened because it is attached to an open invoice. To edit this statement you must ask an administrator to detatach it from the invoice. Then the statement can be reopened and will be eligible for edit.",
        "reopenBilling"
      );
    }
    setTimeout(() => {
      setReopenLoading(false);
    }, 3000);
  };
  const calculateNumberOfDays = (startDate, endDate) => {
    // Parse the dates and set them to start of the day in UTC
    const start = moment.utc(startDate, "MM/DD/YYYY").startOf("day");
    const end = moment.utc(endDate, "MM/DD/YYYY").startOf("day");
  
    console.log(start.format(), "Start Date");
    console.log(end.format(), "End Date");
  
    // Calculate the difference in days
    const numberOfDays = end.diff(start, "days") + 1;
    console.log(numberOfDays, "Total Days");
    
    return numberOfDays;
  };
  const getBillingStatement = async (passingValue, key) => {
    console.log(passingValue, "haaaaaaaaaaaaaa");
    setLoading(true);
    let data = {
      billingStatementId: billid,
      isOrphaned: 1,
    };
    const config = {
      method: "GET",
      url: GET_BILLING_STATEMENT_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        // if(passingValue == 'Add_click'){
        //   upsertLog('add')
        // }
        const {
          BillingStart,
          BillingEnd,
          Hours,
          Miles,
          Lodging,
          Copies,
          Misc,
          DayRate,
          PerDiem,
          MileageRate,
          Total,
          StatusID,
          UserID,
          PeriodKey,
          ProjectID,
          CustomerName,
          BrokerName,
          ProjectName,
          CustomerID,
          IsOrphaned,
        } = parsedResponse.billingStatementDetails[0];
        setIsOrphanedValue(IsOrphaned);
        setBillingStatementDetail({
          ...billingStatementDetail,
          hHours: Hours?.toFixed(2),
          hMiles: Miles,
          hlodging: Lodging?.toFixed(2),
          hcopies: Copies?.toFixed(2),
          hmisc: Misc?.toFixed(2),
          hperdiem: PerDiem,
          hMilegeRate: MileageRate?.toFixed(2),
          hCharges: Total,
          hDayRate: DayRate?.toFixed(2),
          hStatus:
            parseInt(StatusID) == 2
              ? "Statement Closed"
              : parseInt(StatusID) == 1
              ? "Statement Open"
              : parseInt(StatusID) == 3
              ? "Invoice Started"
              : "Invoice Closed",
          // hStartDate:BillingStart,
          hStartDate: moment(BillingStart).utc().format("MM/DD/YYYY"),
          hEndDate: moment(BillingEnd).utc().format("MM/DD/YYYY"),
          huserId: UserID,
          hperiodKey: PeriodKey,
          hprojectID: ProjectID,
          hCustomerName: CustomerName,
          hbokerName: BrokerName,
          hProjectName: ProjectName,
          hCustomerId: CustomerID,
        });

        // if(StatusID == 1){
        //   localStorage.setItem('MILSTATEMENT', MileageRate)
        // }

        // if(StatusID == 1){
        setDayRateMillageRateForBilling((prevState) => ({
          ...prevState,
          statementBilling: {
            ...prevState.statementBilling,
            dayRate: DayRate,
            millageRate: MileageRate,
          },
        }));
        // }
        // setDayRateMillageRateForBilling((prevState) => ({
        //   ...prevState,
        //   statementBilling: {
        //     ...prevState.statementBilling,
        //     dayRate: DayRate,
        //     millageRate: MileageRate,
        //   },
        //   removedBrokerBilling: {
        //     ...prevState.removedBrokerBilling,
        //     millageRate: MileageRate,
        //   },
        // }));

        setCurrentBillingStatus(StatusID);

        let linesEnd = moment(BillingEnd).utc().format("MM/DD/YYYY");
        let linesStart = moment(BillingStart).utc().format("MM/DD/YYYY");
        const noOfLineItems = calculateNumberOfDays(linesStart, linesEnd);
        setNoOfLineItem(noOfLineItems);
        let val = generateInitialValues(noOfLineItems, linesStart);
        console.log("VLUE", values);
        setInitialvalues(val);
        localStorage.setItem("ACTIVE_STATEMENT", StatusID.toString());
        if (StatusID != 1) {
          setBillingStatus(true);
        }
        setActiveStep(parseInt(StatusID) - 1);
        getOrphanedBrokerDetails(UserID, ProjectID);
        if (passingValue && passingValue == "Print_click") {
          window.open(`/print-orphaned-billing-statements/${billid}`, "_blank");
        } else if (passingValue && passingValue == "Add_click") {
          const currentItems = values[key];
          const lastDate = currentItems[currentItems.length - 1].date;
          showToast(`New line item created for date ${lastDate}.`, "success");
          handleAddItem(key);
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          navigate(ADMIN_BILLING_LIST);
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else {
          showToast(v?.message, "error");
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const getOrphanedBrokerDetails = async (UserID, ProjectID) => {
    if (UserID && ProjectID) {
      let data = {
        projectId: ProjectID,
        userId: UserID,
      };
      const config = {
        method: "GET",
        url: GET_ORPHANED_BROKER_DETAILS_LIST_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(data)),
        },
      };
      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);

        console.log(
          "getOrphanedBrokerDetails parsedResponse",
          parsedResponse.billingStatementDetails
        );

        if (
          parsedResponse.status == "Success" &&
          parsedResponse.billingStatementDetails &&
          parsedResponse.billingStatementDetails.length > 0
        ) {
          console.log("getOrphanedBrokerDetails INNNNNN");

          const result = parsedResponse.billingStatementDetails.filter(
            (item) => item.Active == true
          );

          const elseResult = parsedResponse.billingStatementDetails.filter(
            (item) => item.Active == false
          );
          console.log(
            result,
            "ahjkhsjdagsdhsgdh",
            getLogUserId(),
            result[0].UserID,
            elseResult
          );
          if (result && result[0]?.ID) {
            // setDayRateMillageRateForBilling((prevState) => ({
            //   ...prevState,
            //   removedBrokerBilling: {
            //     ...prevState.removedBrokerBilling,
            //     dayRate: result[0]?.DayRate,
            //   },
            // }));

            getBillingProjectDetail(ProjectID, result);

            setOrphanedBillingDetail(result);
            if (getLogUserId() != result.UserID) {
              setIsOrphanentRemovedUser(true);
            }
          }
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          if (v?.message?.accessDenied == 1) {
            showToast(v?.message?.message, "error");
            dispatch({
              type: types.ADMIN_BILLING_STATEMENT_SELECT,
              payload: {
                customerStatus: "",
                projectStatus: "",
                userId: "",
                projectId: "",
                filterValues: {},
              },
            });
            navigate(ADMIN_BILLING_LIST);
          } else if (v?.message?.accessDenied == 2) {
            showToast(v?.message?.message, "error");
            getBillingStatement();
            getBillStatementDetails();
          } else {
            // showToast(v?.message, "error");
          }
        }
      }
    }

    console.log("getOrphanedBrokerDetails", UserID);
    console.log("getOrphanedBrokerDetails", ProjectID);
  };

  useEffect(() => {
    if (billid) {
      getBillingStatement();
    }
  }, [billid]);

  useEffect(() => {
    console.log("dayRateMillageRateForBilling", dayRateMillageRateForBilling);
  }, [dayRateMillageRateForBilling]);

  useEffect(() => {
    if (isFormUpdate) {
      getBillStatementDetails();
      getBillingStatement();
      setIsFormUpdate(false);
    }
  }, [isFormUpdate]);

  const getBillingProjectDetail = async (ProjectID, result) => {
    let data = {
      projectId: ProjectID,
    };
    const config = {
      method: "GET",
      url: GET_PROJECT_DETAILS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        const { BrokerDetails, ProjectDetails } = parsedResponse;

        var activeBrokers = BrokerDetails.find(function (broker) {
          return broker.Active === true;
        });
        const newvalBroker = BrokerDetails.filter((item) => {
          console.log(
            getLogUserId(),
            "kjsakdjksa",
            activeBrokers,
            item?.userID
          );
          return item?.UserID === result[0]?.UserID;
        });

        console.log(
          orphanedBillingDetail[0]?.UserID,
          result,
          "newvalBroker",
          newvalBroker,
          BrokerDetails
        );

        if (ProjectDetails && ProjectDetails[0]) {
          setDayRateMillageRateForBilling((prevState) => ({
            ...prevState,
            brokerBilling: {
              ...prevState.brokerBilling,
              dayRate: newvalBroker[0]?.DayRate,
              millageRate:
                ProjectDetails &&
                ProjectDetails[0] &&
                ProjectDetails[0]?.MileageRate,
            },
            // removedBrokerBilling: {
            //   ...prevState.removedBrokerBilling,
            //   millageRate:
            //     ProjectDetails &&
            //     ProjectDetails[0] &&
            //     ProjectDetails[0].MileageRate,
            // },
          }));
        }

        console.log(currentBillingStatus, "cureennnnnnnnn");
        // if(currentBillingStatus == 1){
        //   localStorage.setItem('MILSTATEMENT', ProjectDetails[0] &&
        //     ProjectDetails[0].MileageRate,)
        // }

        console.log(getLogUserId(), "gggggggggggggg");
        const formattedBroker = newvalBroker.map((broker) => ({
          ...broker,
          PayableOfficePerDiem: parseFloat(broker.PayableOfficePerDiem).toFixed(
            2
          ),
          PayableTravelPerDiem: parseFloat(broker.PayableTravelPerDiem).toFixed(
            2
          ),
        }));

        setProjectDetailsVal(ProjectDetails);
        // if (activeStateClose == 2) {
        //   localStorage.setItem("DAYSTATEMENT", newvalBroker[0].DayRate);
        // } else {
        setBrokerDetailsval(formattedBroker);
        // setBrokerDetailsval(newvalBroker);
        // }

        if (activeBrokers && activeBrokers.UserID) {
          dispatch(getPerDiemList(ProjectID, activeBrokers.UserID));
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          navigate(ADMIN_BILLING_LIST);
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else {
          showToast(v?.message, "error");
        }
      }
    }
  };

  const getBillStatementDetails = async (upsertInvoiceValues, deleteApi) => {
    setLoading(true);
    let data = {
      headerId: parseInt(billid),
    };
    const config = {
      method: "GET",
      url: GET_BILLING_STATEMENT_DETAILS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        if (parsedResponse.billingStatementDetails) {
          setResponseBill(parsedResponse.billingStatementDetails);

          if (deleteApi == "Delete") {
            upsertBillingDetailsFunForDelete(
              parsedResponse.billingStatementDetails
            );
          }

          if (upsertInvoiceValues) {
            let totalHours = 0;
            let totalMiles = 0;
            let totalPerDiem = 0;
            let totalCopies = 0;
            let totalLodging = 0;
            let totalMisc = 0;
            let totalMilege = 0;
            let postDataArray = [];

            // Loop through billing statement details
            parsedResponse.billingStatementDetails.forEach((item) => {
              console.log("Processing item:", item);

              const {
                Lodging,
                BillingType,
                Hours,
                PerDiem,
                PerDiemRate,
                Miles,
                Misc,
                Copies,
                mileageRate,
                Date,
                Description,
                billingStatementDetailsId,
              } = item;

              const parsedHours = parseFloat(Hours) || 0;
              const parsedMiles = parseFloat(Miles) || 0;
              const parsedPerDiemRate = PerDiemRate
                ? parseFloat(PerDiemRate)
                : 0;
              const parsedCopies = parseFloat(Copies) || 0;
              const parsedLodging = parseFloat(Lodging) || 0;
              const parsedMisc = parseFloat(Misc) || 0;
              const parsedMileageRate = parseFloat(mileageRate) || 0;

              // Calculate per diem
              const calculatedPerDiem = calculatePerDiem(
                parsedHours,
                parsedPerDiemRate
              );
              console.log("calculatedPerDiem:", calculatedPerDiem);

              // Accumulate totals
              totalHours += parsedHours;
              totalMiles += parsedMiles;
              totalPerDiem += Number(calculatedPerDiem);
              totalCopies += parsedCopies;
              totalLodging += parsedLodging;
              totalMisc += parsedMisc;
              totalMilege += parsedMileageRate;

              // Prepare post data
              let postData = {
                billingStatementDetailsId: billingStatementDetailsId || 0,
                headerId: billid,
                billingType: BillingType,
                date: Date,
                hours: parsedHours,
                perDiemRate: parsedPerDiemRate,
                perDiem: Number(calculatedPerDiem),
                lodging: parsedLodging,
                miles: parsedMiles,
                misc: parsedMisc,
                copies: parsedCopies,
                description: Description || "",
              };

              postDataArray.push(postData);
            });

            // Set final calculated totals
            setBillingStatementDetail((prevState) => ({
              ...prevState,
              hHours: Number(totalHours).toFixed(2),
              hMiles: totalMiles.toString(),
              hperdiem: Number(totalPerDiem || 0).toFixed(2),
              hlodging: Number(totalLodging || 0).toFixed(2),
              hcopies: totalCopies.toString(),
              hMilegeRate: Number(totalMilege || 0).toFixed(2),
              hmisc: Number(totalMisc || 0).toFixed(2),
            }));

            var charges = 0;
            if (totalHours && upsertInvoiceValues?.dayRate) {
              charges = (totalHours / 8) * upsertInvoiceValues?.dayRate;
            }

            const totalValue =
              (totalPerDiem ? parseFloat(totalPerDiem) : 0) +
              (totalLodging ? parseFloat(totalLodging) : 0) +
              (totalCopies ? parseFloat(totalCopies) : 0) +
              (totalMisc ? parseFloat(totalMisc) : 0) +
              (charges ? parseFloat(charges) : 0) +
              (totalMiles ? parseFloat(totalMiles) : 0) *
                (upsertInvoiceValues?.mileageRate
                  ? parseFloat(upsertInvoiceValues?.mileageRate)
                  : 0);

            console.log("totalValuetotalValue", totalValue);
            console.log(
              "Post Data for CREATE_UPDATE_BILLING_STATEMENT_URL: CALLING",
              upsertInvoiceValues
            );
            // Prepare the data for the second API call (CREATE/UPDATE Billing Statement)
            let postData1 = {
              billingStatementId: upsertInvoiceValues?.billingStatementId,
              userId: getLogUserId(), // Ensure this returns the correct userId
              periodKey: upsertInvoiceValues?.periodKey,
              projectId: upsertInvoiceValues?.projectId,
              // Correct statusId handling
              statusId: upsertInvoiceValues?.statusId, // Compare with number (2 or 1) or the actual condition for "closed"
              billingStart: upsertInvoiceValues?.billingStart,
              billingEnd: upsertInvoiceValues?.billingEnd,
              hours: totalHours,
              dayRate: upsertInvoiceValues?.dayRate,
              perDiem: totalPerDiem,
              lodging: totalLodging,
              miles: totalMiles,
              misc: totalMisc,
              copies: totalCopies,
              mileageRate: upsertInvoiceValues?.mileageRate,
              // Ensure total is a number and format it to 2 decimal places
              total: Number(totalValue).toFixed(2),
            };

            // Log postData to check what will be sent in the API request
            console.log(
              "Post Data for CREATE_UPDATE_BILLING_STATEMENT_URL:",
              postData1
            );
            updateHeaderDetails(postData1);
            // Refresh billing statement details
            // getBillingStatement();
          }
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          navigate(ADMIN_BILLING_LIST);
        } else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getBillingStatement();
          getBillStatementDetails();
        } else {
          // showToast(v?.message, "error");
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const updateHeaderDetails = async (postData1, billid, status, val, type) => {
    // Log to indicate the function has been called
    console.log("CALLLLLLLLLLLLLLLLl");

    // Log postData1 to ensure it contains the expected data
    console.log("Post Data:", postData1);

    // Check if authHeader() returns the expected headers
    console.log("Headers:", authHeader());

    // Define the configuration for the API call
    const config = {
      method: "POST",
      headers: authHeader(),
      url: CREATE_UPDATE_BILLING_STATEMENT_URL,
      data: {
        webString: enCryptFun(JSON.stringify(postData1)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        if (type == "No_Need_Api_Close_Invoice") {
          updateBillingStatus(billid, status, val, type);
        } else {
          if (parsedResponse?.message != "Record saved successfully.") {
            showToast(parsedResponse?.message, "success");
          }
          console.log(parsedResponse, "rsposssssssss");
          setFormSaved(true);
          setShowWarning(false);
          setWarningHighlightColor(false);
          setChangedFields({});
          setIsFormDirty(false);
        }
      }
    } catch (error) {
      // Log the error if the API call fails
      console.error(
        "Error in API call:",
        error.response?.data || error.message
      );
    } finally {
      setIsFormUpdate(true);
    }
  };

  const upsertLog = async (type, date) => {
    let logData = {
      logTypeID: type == "add" ? 59 : 60,
      logUser: getLogUserId(),
      target: billid,
      // target: billingStatementDetail.hprojectID,
      target2: billingStatementDetail.hCustomerId,
      description:
        type == "add"
          ? `New Orphaned Billing line item created for date ${
              date ? date : moment(new Date()).format("DD/MM/YYYY")
            } in project '${
              billingStatementDetail.hProjectName
            }' for customer '${billingStatementDetail.hCustomerName}'.`
          : `Orphaned Billing line item removed for date ${
              date ? date : moment(new Date()).format("DD/MM/YYYY")
            } in project '${
              billingStatementDetail.hProjectName
            }' for customer '${billingStatementDetail.hCustomerName}'.`,
    };
    const config = {
      method: "POST",
      headers: authHeader(),
      url: SYSTEM_LOG_INSERT_URL,
      data: {
        webString: enCryptFun(JSON.stringify(logData)),
      },
    };
    try {
      const resp = await API(config);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!responseBill || !isInitialized) return;

    const myResponseLookup = responseBill.reduce((acc, item) => {
      const formattedDate = moment(item.Date).utc().format("MM/DD/YYYY");
      if (!acc[`lineItem${formattedDate}`]) {
        acc[`lineItem${formattedDate}`] = [];
      }
      acc[`lineItem${formattedDate}`].push(item);

      acc[`lineItem${formattedDate}`] = acc[`lineItem${formattedDate}`].sort(
        (a, b) => a.billingStatementDetailsId - b.billingStatementDetailsId
      );
      return acc;
    }, {});

    let dayRateUpdated =
      currentBillingStatus === "1" &&
      dayRateMillageRateForBilling.brokerBilling.dayRate !== 0
        ? dayRateMillageRateForBilling.brokerBilling.dayRate
        : dayRateMillageRateForBilling.statementBilling.dayRate !== 0
        ? dayRateMillageRateForBilling.statementBilling.dayRate
        : localStorage?.getItem("DAYSTATEMENT");

    setValues((prevValues) => {
      const newValues = initialValues
        ? JSON.parse(JSON.stringify(initialValues))
        : {}; // Deep copy to avoid nested state issues

      Object.keys(myResponseLookup).forEach((key) => {
        const newItems = myResponseLookup[key].map((item) => ({
          billingType: item.BillingType,
          //dayRate: BillingDayRate,
          // dayRate: PayableDayRate,
          dayRate: dayRateUpdated,
          hours: parseFloat(item.Hours).toFixed(2), // Ensure numeric types are handled correctly
          miles: item.Miles,
          lodging: parseFloat(item.Lodging).toFixed(2),
          description: item.Description,
          date: moment(item.Date).utc().format("MM/DD/YYYY"),
          copies: parseFloat(item.Copies).toFixed(2),
          perDiemRate: parseFloat(item.PerDiemRate).toFixed(2) || 0.0,
          billingStatementDetailsId: item.billingStatementDetailsId,
          perDiem: calculatePerDiem(item.Hours, item.PerDiemRate),
          misc: parseFloat(item.Misc)?.toFixed(2),
          IsOfficePerDiem: item?.IsOfficePerDiem,
          IsTravelPerDiem: item?.IsTravelPerDiem,
        }));

        newValues[key] = newItems;
      });

      return newValues;
    });
  }, [responseBill, isInitialized]);

  // const calculatePerDiem = (hours, perDiemRate) => {
  //   hours = parseFloat(hours);
  //   perDiemRate = perDiemRate ? parseFloat(perDiemRate): 0.00;
  //   if (hours >= 8) {
  //     return perDiemRate ? perDiemRate : "0.00";
  //   } else {
  //     console.log("hrs", hours, perDiemRate, (hours / 8) * perDiemRate);
  //     return ((hours / 8) * perDiemRate).toFixed(2)
  //       ? ((hours / 8) * perDiemRate).toFixed(2)
  //       : "0.00";
  //   }
  // };
  const handleChangeperdiem = (e) => {
    const { name, value } = e.target;
    const [lineItemKey, index, field] = name.split(/[.[\]]/).filter(Boolean);

    setValues((prevValues) => {
      const updatedValues = { ...prevValues };
      updatedValues[lineItemKey][index][field] = value;

      // Update per diem value when hours or perDiemRate change
      if (field === "hours" || field === "perDiemRate") {
        const { hours, perDiemRate } = updatedValues[lineItemKey][index];
        let pD = calculatePerDiem(hours, perDiemRate);
        updatedValues[lineItemKey][index].perDiem = pD ? pD : "0.00";
      }

      return updatedValues;
    });
    // handleChange(e)
  };
  const BackFun = () => {
    navigate(ADMIN_BILLING_LIST);
  };

  const calculateTotalCharges = () => {
    //let charge = parseFloat((billingStatementDetail.hHours / 8) * BillingDayRate).toFixed(2);
    let charge = parseFloat(
      (billingStatementDetail.hHours / 8) * PayableDayRate
    ).toFixed(2);
    setBillingStatementDetail({ ...billingStatementDetail, hCharges: charge });
    return charge;
  };

  // const handlePrintBillingStatement = () => {
  //   if (billid) {
  //     window.open(`/print-billing-statements/${billid}`, "_blank");
  //   }
  // };

  const handlePrintBillingStatement = async () => {
    try {
      // Wait for the billing statement to be fetched before continuing
      await getBillingStatement("Print_click");
    } catch (error) {
      console.error("Error fetching billing statement:", error);
    }
  };

  const handleNavigateAway = () => {
    setShowWarning(true);
    setBackNavigateArrow(true);
    // if (formSaved) {
    //   setFormSaved(false)
    //   // setOpenModal(true);
    // } else {
    //   console.log("Navigating away");
    // }
  };

  useEffect(() => {
    const isFormChanged = !isEqual(values, initialValues);
    if (!formSaved && isFormChanged) {
      setIsFormDirty(true);
      setFormSaved(!isFormChanged);
    }
    console.log(isFormChanged, "isFormChanged");
  }, [values, initialValues]);

  // Warn user on browser navigation
  useEffect(() => {
    if (!formSaved && backNavigateArrow) {
      setFormSaved(true);
    }
    console.log(warningHighlighted, "warningHighlightedwarningHighlighted");
    const handleBeforeUnload = (event) => {
      if (!formSaved && backNavigateArrow) {
        // setShowWarning(true);
        // Synchronously update state and warn the user
        setWarningHighlightColor(true);
        event.preventDefault(); // Necessary for some browsers to trigger warning
        event.returnValue = ""; // Most browsers will show a generic message
      }
    };

    const handlePopState = (event) => {
      if (!formSaved) {
        setShowWarning(true);
        setWarningHighlightColor(true);
        setBackNavigateArrow(true);
        window.history.pushState(null, null, window.location.href);
      } else {
        // Navigate to the billingstatement page
        window.location.assign("/billingstatement");
      }
    };

    // Set up event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    // Initial push state to handle browser back button
    if (!formSaved) {
      console.log(formSaved, "formmmmmmmmmmmmmmmm");
      // setShowWarning(true);
      // setWarningHighlightColor(true);
      // setBackNavigateArrow(true);
      window.history.pushState(null, null, window.location.href);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [formSaved]);

  const confirmNavigation = (confirmed) => {
    setShowWarning(false);
    if (confirmed) {
      setFormSaved(true); // Allow navigation
      window.history.back();
    }
  };

  const handleNoClick = () => {
    setShowWarning(false);
    setWarningHighlightColor(true);
  };

  const handleYesClick = () => {
    if (backNavigateArrow) {
      navigate(ADMIN_BILLING_LIST);
    } else if (closeBillingAlert) {
      const newCompleted = completed;
      newCompleted[activeStep] = true;
      setCompleted(newCompleted);
      setActiveStep(1);
      setBillingStatus(true);
      updateBillingStatus(billid, 2, "closeBilling");
      setShowWarning(false);
      setFormSaved(true);
      setWarningHighlightColor(false);
    } else {
      dispatch(getLoggedUserDetails());
      getBillingStatement();
      setShowWarning(false);
      setWarningHighlightColor(false);
      setFormSaved(true);
      setValues(initialValues);
    }
  };

  useEffect(() => {
    getBillStatementDetails();
    setDetailLoading(true);
    setTimeout(() => {
      setDetailLoading(false);
    }, 4000);
  }, []);

  useEffect(() => {
    const activeState = localStorage.getItem("ACTIVE_STATEMENT");
    const dayStatement = localStorage.getItem("DAYSTATEMENT");

    console.log("ACTIVE_STATEMENT:", activeState);
    console.log("DAYSTATEMENT:", dayStatement);
    setDAyPrev(dayStatement);
    setActiveStateClose(activeState);
  }, [values]);

  useEffect(() => {
    if (isNewitemAdded) {
      setIsNewitemAdded(false);
      setInitialvalues(values);
      console.log("values from", isNewitemAdded);
    }
  }, [isNewitemAdded]);

  const BrokeNameFilter = brokerDetailsVal.find(
    (item) => item?.BrokerName === billingStatementDetail?.hbokerName
  );
  const userRoles = getLogUserRole();

  const testing1 =
    (userRoles.includes("Admin") && userRoles.includes("Broker")) ||
    userRoles.includes("Admin")
      ? "3"
      : "0";

  // useEffect(() => {
  //   console.log(bid.length,'biddddddddddd')
  //   // Check if bid is a number and has more than 3 digits
  //   if (!(/^\d*$/).test(bid)) {
  //     // If bid is invalid (e.g., less than 4 digits), redirect to the dashboard
  //     navigate(PAGE_NOT_FOUND_PATH, { replace: true });
  //   }
  // }, [bid, navigate]);

  return (
    <>
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide={testing1} />
        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar
            title="Billing Statement"
            backFlag={true}
            backRoute={formSaved ? ADMIN_BILLING_LIST : handleNavigateAway}
          />

          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
          >
            {(loading || detailLoading) && <CustomPageLoading />}

            <Grid xs={12} md={9}>
              <Box
                sx={{
                  p: "16px 17px",
                  ml: { xs: "0px", sm: "20px" },
                  pb: "9px",
                }}
                className="bg-box"
              >
                <Box className="billing-box">
                  <Typography className="billing-title">
                    Billing Period
                  </Typography>
                  <Typography sx={{ mt: "8px" }} className="bill-date">
                    {billingStatementDetail.hStartDate} -{" "}
                    {billingStatementDetail.hEndDate}
                  </Typography>
                </Box>
                <Box sx={{ width: "100%", mt: "7px" }}>
                  <Stepper
                    className="bill-stepper"
                    nonLinear
                    activeStep={activeStep}
                  >
                    {steps.map((label, index) => {
                      return (
                        <Step key={label} completed={completed[index]}>
                          <StepButton
                            className={activeStep == index ? "step-active" : ""}
                            color="inherit"
                            onClick={handleStep(index)}
                          >
                            {index < activeStep ? (
                              // {completed[index] && index === 0 ? (
                              <img src={CircleGreenIconSvg} alt="Completed" />
                            ) : (
                              <CircleIcon />
                            )}
                            {label}
                          </StepButton>
                        </Step>
                      );
                    })}
                  </Stepper>
                  <div>
                    {allStepsCompleted() ? (
                      <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                          All steps completed - you&apos;re finished
                        </Typography>
                        <Box
                          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                        >
                          <Box sx={{ flex: "1 1 auto" }} />
                          <Button onClick={handleReset}>Reset</Button>
                        </Box>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <Typography
                          sx={{
                            mb: 1,
                            py: 1,
                            pt: 0,
                            position: {
                              xs: "unset",
                              sm: "unset",
                              md: "unset",
                              lg: "sticky",
                            },

                            top: "0px",
                            zIndex: "9",
                            borderTop: "10px solid #fff",
                            borderBottom: "10px solid #fff",
                            marginBottom: 0,
                            paddingBottom: 0,
                          }}
                        >
                          <Box
                            sx={{ pt: "10px", pb: "12px", borderRadius: "0px" }}
                            className="billing-box"
                          >
                            <Grid
                              sx={{ ml: "0" }}
                              container
                              rowSpacing={1}
                              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            >
                              <Grid item xs={12} md={4}>
                                <Typography className="state-titles">
                                  Customer:
                                </Typography>
                                <Typography className="state-values">
                                  {billingStatementDetail.hCustomerName}
                                </Typography>
                                <Typography className="state-titles">
                                  Project:
                                </Typography>
                                <Typography className="state-values">
                                  {billingStatementDetail.hProjectName}
                                </Typography>
                                <Typography className="state-titles">
                                  Broker:
                                </Typography>
                                <Typography className="state-values">
                                  {BrokeNameFilter?.BrokerName ===
                                  billingStatementDetail?.hbokerName
                                    ? `${BrokeNameFilter?.FirstName} ${BrokeNameFilter?.LastName}`
                                    : billingStatementDetail?.hbokerName}
                                </Typography>
                                <Typography className="state-titles">
                                  Status:
                                </Typography>
                                <Typography
                                  sx={{ mb: "0 !important" }}
                                  className="state-values"
                                >
                                  {billingStatementDetail.hStatus}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <Typography className="state-titles">
                                  Hours:
                                </Typography>
                                <Typography className="state-values">
                                  {billingStatementDetail.hHours &&
                                  billingStatementDetail.hHours != "0.00"
                                    ? parseFloat(
                                        billingStatementDetail.hHours
                                      ).toFixed(2)
                                    : "0.00"}
                                </Typography>
                                <Typography
                                  sx={{ position: "relative" }}
                                  className="state-titles"
                                >
                                  Charges:
                                  <span>
                                    <span
                                      style={{
                                        position: "absolute",
                                        fontSize: "15px",
                                        cursor: "pointer",
                                      }}
                                      aria-owns={
                                        open ? "mouse-over-popover" : undefined
                                      }
                                      aria-haspopup="true"
                                      onMouseEnter={handlePopoverOpen}
                                      onMouseLeave={handlePopoverClose}
                                      class="material-symbols-outlined"
                                    >
                                      help
                                    </span>
                                  </span>
                                </Typography>
                                <Popover
                                  className="charges-box"
                                  id="mouse-over-popover"
                                  sx={{
                                    pointerEvents: "none",
                                  }}
                                  open={open}
                                  anchorEl={anchorEl}
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "center",
                                  }}
                                  transformOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center",
                                  }}
                                  onClose={handlePopoverClose}
                                  disableRestoreFocus
                                >
                                  <Typography className="charges-title">
                                    Charges
                                  </Typography>
                                  <Box>
                                    <Box class="time-flexbox">
                                      <Typography className="charge-price">
                                        {billingStatementDetail.hHours}
                                      </Typography>
                                      <Typography className="charge-text">
                                        hours
                                      </Typography>
                                    </Box>
                                    <Box class="time-flexbox">
                                      <Typography className="charge-price">
                                        /8
                                      </Typography>
                                      <Typography className="charge-text">
                                        hour work day
                                      </Typography>
                                    </Box>
                                    <Divider
                                      sx={{
                                        borderColor: "#F2F4F8",
                                        margin: "5px 0px",
                                      }}
                                    />
                                    <Box class="time-flexbox">
                                      <Typography className="charge-price">
                                        {billingStatementDetail.hHours / 8}
                                      </Typography>
                                      <Typography className="charge-text">
                                        billable days
                                      </Typography>
                                    </Box>
                                    <Box class="time-flexbox">
                                      <Typography className="charge-price">
                                        {/* x ${BillingDayRate} */}x $
                                        {/* {brokerDetailsVal?.length
                                          ? brokerDetailsVal[0].DayRate.toString()
                                          :  0.00} */}
                                        {currentBillingStatus == "1" &&
                                        dayRateMillageRateForBilling
                                          .brokerBilling.dayRate != 0
                                          ? dayRateMillageRateForBilling.brokerBilling.dayRate?.toFixed(
                                              2
                                            )
                                          : dayRateMillageRateForBilling
                                              .statementBilling.dayRate != 0
                                          ? dayRateMillageRateForBilling.statementBilling.dayRate?.toFixed(
                                              2
                                            )
                                          : localStorage?.getItem(
                                              "DAYSTATEMENT"
                                            )}
                                        {/* {activeStateClose != "1"
                                          ? DAYPrev
                                          : brokerDetailsVal?.length
                                          ? brokerDetailsVal[0].DayRate.toString()
                                          : projectDetailsval?.length
                                          ? projectDetailsval[0]?.BillingDayRate
                                          : PayableDayRate || 0.0} */}
                                        {/* {projectDetailsval?.length
                                          ? projectDetailsval[0]?.BillingDayRate.toFixed(
                                              2
                                            )
                                          : PayableDayRate
                                          ? PayableDayRate.toFixed(2)
                                          : 0.0} */}
                                      </Typography>
                                      <Typography className="charge-text">
                                        day rate
                                      </Typography>
                                    </Box>
                                    <Box class="time-flexbox time-btn">
                                      <Typography className="charge-price total-charge">
                                        {/* {parseFloat((billingStatementDetail.hHours / 8) * BillingDayRate).toFixed(2)} */}
                                        {/* {parseFloat(
                                          (billingStatementDetail.hHours / 8) *
                                            PayableDayRate
                                        ).toFixed(2)} */}
                                        {/* {billingStatementDetail.hHours &&
                                        projectDetailsval?.length
                                          ? projectDetailsval[0]?.BillingDayRate
                                          : PayableDayRate
                                          ? parseFloat(
                                              (billingStatementDetail.hHours /
                                                8) *
                                                (projectDetailsval?.length
                                                  ? projectDetailsval[0]
                                                      ?.BillingDayRate
                                                  : PayableDayRate)
                                            ).toFixed(2)
                                          : "0.00"} */}
                                        $
                                        {parseFloat(
                                          (billingStatementDetail.hHours / 8) *
                                            (currentBillingStatus == "1" &&
                                            dayRateMillageRateForBilling
                                              .brokerBilling.dayRate != 0
                                              ? dayRateMillageRateForBilling
                                                  .brokerBilling.dayRate
                                              : dayRateMillageRateForBilling
                                                  .statementBilling.dayRate != 0
                                              ? dayRateMillageRateForBilling
                                                  .statementBilling.dayRate
                                              : localStorage?.getItem(
                                                  "DAYSTATEMENT"
                                                ))
                                          // (activeStateClose != "1"
                                          //   ? DAYPrev
                                          //   : brokerDetailsVal?.length
                                          //   ? brokerDetailsVal[0].DayRate.toString()
                                          //   : projectDetailsval?.length
                                          //   ? projectDetailsval[0]
                                          //       ?.BillingDayRate
                                          //   : PayableDayRate || 0.0)
                                        ).toFixed(2)}
                                        {/* {billingStatementDetail.hCharges
                                          ? Number(
                                              billingStatementDetail.hCharges
                                            ).toFixed(2)
                                          : 0.0}11 */}
                                      </Typography>
                                      <Typography className="charge-text">
                                        total charge
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Popover>
                                <Typography className="state-values">
                                  $
                                  {parseFloat(
                                    (billingStatementDetail.hHours / 8) *
                                      (currentBillingStatus == "1" &&
                                      dayRateMillageRateForBilling.brokerBilling
                                        .dayRate != 0
                                        ? dayRateMillageRateForBilling
                                            .brokerBilling.dayRate
                                        : dayRateMillageRateForBilling
                                            .statementBilling.dayRate != 0
                                        ? dayRateMillageRateForBilling
                                            .statementBilling.dayRate
                                        : localStorage?.getItem("DAYSTATEMENT"))
                                    // (activeStateClose != "1"
                                    //   ? DAYPrev
                                    //   : brokerDetailsVal?.length
                                    //   ? brokerDetailsVal[0].DayRate.toString()
                                    //   : projectDetailsval?.length
                                    //   ? projectDetailsval[0]?.BillingDayRate
                                    //   : PayableDayRate || 0.0)
                                  ).toFixed(2)}
                                </Typography>
                                <Typography className="state-titles">
                                  Miles:
                                </Typography>
                                <Typography className="state-values">
                                  {billingStatementDetail.hMiles
                                    ? parseFloat(
                                        billingStatementDetail.hMiles
                                      ).toFixed(2)
                                    : "0.00"}
                                </Typography>
                                <Typography className="state-titles">
                                  Mileage Rate:
                                </Typography>
                                <Typography
                                  sx={{ mb: "0 !important" }}
                                  className="state-values"
                                >
                                  $
                                  {currentBillingStatus == "1" &&
                                  dayRateMillageRateForBilling.brokerBilling
                                    .millageRate != 0
                                    ? dayRateMillageRateForBilling.brokerBilling.millageRate?.toFixed(
                                        3
                                      )
                                    : dayRateMillageRateForBilling
                                        .statementBilling.millageRate != 0
                                    ? dayRateMillageRateForBilling.statementBilling.millageRate?.toFixed(
                                       3
                                      )
                                    : localStorage.getItem("MILSTATEMENT")}
                                  {/* {activeStateClose != 1
                                    && milegaePrev ? milegaePrev
                                    : MileageRate && MileageRate != "0.00"
                                    ? parseFloat(MileageRate).toFixed(2)
                                    : "0.00"} */}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <Typography className="state-titles">
                                  Per Diem:
                                </Typography>
                                <Typography className="state-values">
                                  $
                                  {billingStatementDetail.hperdiem &&
                                  billingStatementDetail.hperdiem != "0.00"
                                    ? parseFloat(
                                        billingStatementDetail.hperdiem
                                      ).toFixed(2)
                                    : "0.00"}
                                </Typography>
                                <Typography className="state-titles">
                                  Lodging:
                                </Typography>
                                <Typography className="state-values">
                                  $
                                  {billingStatementDetail.hlodging &&
                                  billingStatementDetail.hlodging != "0.00"
                                    ? parseFloat(
                                        billingStatementDetail.hlodging
                                      ).toFixed(2)
                                    : "0.00"}
                                </Typography>
                                <Typography className="state-titles">
                                  Copies:
                                </Typography>
                                <Typography className="state-values">
                                  $
                                  {billingStatementDetail.hcopies &&
                                  billingStatementDetail.hcopies != "0.00"
                                    ? parseFloat(
                                        billingStatementDetail.hcopies
                                      ).toFixed(2)
                                    : "0.00"}
                                </Typography>
                                <Typography className="state-titles">
                                  Misc: 
                                </Typography>
                                <Typography
                                  sx={{ mb: "0 !important" }}
                                  className="state-values"
                                >
                                  $
                                  {billingStatementDetail.hmisc &&
                                  billingStatementDetail.hmisc != "0.00"
                                    ? parseFloat(
                                        billingStatementDetail.hmisc
                                      ).toFixed(2)
                                    : "0.00"}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Box>
                        </Typography>
                        <div className={formSaved ? "" : "unsaved-changes"}>
                          <form onSubmit={handleSubmit}>
                            {values &&
                              Object.keys(values)
                                .filter((key) => key.startsWith("lineItem"))
                                .map((key) =>
                                  values[key].map((item, index) => {
                                    return (
                                      <Box
                                        className="bill-form-box"
                                        key={`${key}-${index}`}
                                      >
                                        <Stack
                                          className="bill-form-title"
                                          direction={{
                                            xs: "column",
                                            sm: "row",
                                          }}
                                          spacing={{ xs: 1, sm: 2, md: 2 }}
                                          justifyContent="space-between"
                                          sx={{
                                            alignItems: {
                                              xs: "flex-start",
                                              md: "center",
                                            },
                                          }}
                                        >
                                          <Typography className="billing-boxdate-title">
                                            {/* {moment(new Date()).format('MM/DD/YYYY')} */}
                                            {/* {calculateDate(index)} */}
                                            {item.date}
                                          </Typography>

                                          <Stack
                                            className="icon-btn-box"
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                          >
                                            {values[key].length > 1 && (
                                              <Tooltip
                                                title="Remove this line"
                                                arrow
                                                placement="top"
                                              >
                                                <IconButton
                                                  className="delete-icon-btn"
                                                  aria-label="fingerprint"
                                                  color="secondary"
                                                  disabled={billingStatus}
                                                  onClick={() => {
                                                    setItemRemoveConfirmStatus(
                                                      true
                                                    );
                                                    setItemRemoveConfirmItem({
                                                      date: item.date,
                                                      key: key,
                                                      index: index,
                                                    });
                                                  }}
                                                >
                                                  <span class="material-symbols-outlined">
                                                    delete
                                                  </span>
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                            <Tooltip
                                              title="Add line to this day"
                                              arrow
                                              placement="top"
                                            >
                                              <IconButton
                                                className="add-icon-btn"
                                                aria-label="fingerprint"
                                                color="secondary"
                                                disabled={
                                                  billingStatus ||
                                                  saveLoading ||
                                                  loading ||
                                                  detailLoading
                                                }
                                                onClick={async () => {
                                                  try {
                                                    // Wait for the billing statement to be fetched before continuing
                                                    await getBillingStatement(
                                                      "Add_click",
                                                      key
                                                    );
                                                    await checkBillingProjectDetail(
                                                      billingStatementDetail?.hprojectID
                                                    );
                                                  } catch (error) {
                                                    console.error(
                                                      "Error handling billing statement or adding item:",
                                                      error
                                                    );
                                                  }
                                                }}
                                              >
                                                <span class="material-symbols-outlined">
                                                  add
                                                </span>
                                              </IconButton>
                                            </Tooltip>
                                            <Tooltip
                                              title="Save"
                                              arrow
                                              placement="top"
                                            >
                                              <IconButton
                                                disabled={
                                                  billingStatus ||
                                                  saveLoading ||
                                                  loading ||
                                                  detailLoading
                                                }
                                                className="save-icon-btn"
                                                aria-label="fingerprint"
                                                color="secondary"
                                                data-billstateid={
                                                  item.billingStatementDetailsId
                                                }
                                                onClick={() =>
                                                  handleSaveItem(
                                                    key,
                                                    index,
                                                    item.billingStatementDetailsId
                                                  )
                                                }
                                              >
                                                <span class="material-symbols-outlined">
                                                  save
                                                </span>
                                              </IconButton>
                                            </Tooltip>
                                          </Stack>
                                        </Stack>

                                        <Box className="bill-formbox-inside">
                                          <Stack
                                            direction={{
                                              xs: "column",
                                              sm: "row",
                                            }}
                                            spacing={{
                                              xs: 1,
                                              sm: 1.5,
                                              md: 1.5,
                                            }}
                                            justifyContent="space-between"
                                            sx={{
                                              alignItems: {
                                                xs: "flex-start",
                                                md: "center",
                                              },
                                              display: {
                                                xs: "unset",
                                                sm: "grid",
                                                md: "grid",
                                                lg: "flex",
                                              },
                                              gridTemplateColumns: {
                                                xs: "unset",
                                                sm: "repeat(3, 1fr)",
                                                md: "repeat(3, 1fr)",
                                                lg: "unset",
                                              },
                                              rowGap: "10px !important",
                                            }}
                                          >
                                            <FormControl
                                              sx={{ minWidth: "140px" }}
                                            >
                                              <p className="label">
                                                Billing Type
                                              </p>
                                              <Select
                                                sx={{
                                                  "& .MuiOutlinedInput-notchedOutline":
                                                    {
                                                      border:
                                                        warningHighlighted &&
                                                        isFormDirty &&
                                                        changedFields[
                                                          `${key}[${index}].billingType`
                                                        ]
                                                          ? "yellow"
                                                          : "",
                                                      borderWidth:
                                                        warningHighlighted &&
                                                        isFormDirty &&
                                                        changedFields[
                                                          `${key}[${index}].billingType`
                                                        ]
                                                          ? "1px"
                                                          : "",
                                                      outline:
                                                        warningHighlighted &&
                                                        isFormDirty &&
                                                        changedFields[
                                                          `${key}[${index}].billingType`
                                                        ]
                                                          ? "1px solid yellow"
                                                          : "",
                                                    },
                                                  "& .MuiSelect-select": {
                                                    color:
                                                      item.billingType === "" ||
                                                      item.billingType
                                                        ? "#212121"
                                                        : "#898989",
                                                  },
                                                }}
                                                disabled={billingStatus}
                                                name={`${key}[${index}].billingType`}
                                                displayEmpty
                                                onChange={(event) =>
                                                  handleChange1(
                                                    event,
                                                    key,
                                                    index
                                                  )
                                                }
                                                IconComponent={
                                                  KeyboardArrowDownIcon
                                                }
                                                value={item.billingType || ""}
                                              >
                                                <MenuItem
                                                  selected
                                                  disabled
                                                  value=""
                                                >
                                                  Select Bill type
                                                </MenuItem>
                                                {billTypeList.map((rec) => (
                                                  <MenuItem
                                                    key={rec.id}
                                                    value={rec.id}
                                                  >
                                                    {rec.name}
                                                  </MenuItem>
                                                ))}
                                              </Select>
                                              {errors[key]?.[index]
                                                ?.billingType &&
                                                touched[key]?.[index]
                                                  ?.billingType && (
                                                  <FormHelperText error={true}>
                                                    {
                                                      errors[key][index]
                                                        .billingType
                                                    }
                                                  </FormHelperText>
                                                )}
                                            </FormControl>

                                            <FormControl variant="standard">
                                              <p className="label">Day Rate</p>
                                              <Input
                                                className="default-btn dollar-field"
                                                disabled
                                                name="defaultDayRate"
                                                id="defaultDayRate"
                                                // onChange={handleChange}
                                                // disabled={editFlag}
                                                //value={BillingDayRate || 0.0}
                                                // value={
                                                //   activeStateClose != "1"
                                                //     ? DAYPrev
                                                //     : brokerDetailsVal?.length
                                                //     ? brokerDetailsVal[0].DayRate.toString()
                                                //     : projectDetailsval?.length
                                                //     ? projectDetailsval[0]
                                                //         ?.BillingDayRate
                                                //     : PayableDayRate || 0.0
                                                // }

                                                value={
                                                  currentBillingStatus == "1" &&
                                                  dayRateMillageRateForBilling
                                                    .brokerBilling.dayRate != ""
                                                    ? dayRateMillageRateForBilling.brokerBilling.dayRate?.toFixed(
                                                        2
                                                      )
                                                    : dayRateMillageRateForBilling
                                                        .statementBilling
                                                        .dayRate != ""
                                                    ? dayRateMillageRateForBilling.statementBilling.dayRate?.toFixed(
                                                        2
                                                      )
                                                    : localStorage?.getItem(
                                                        "DAYSTATEMENT"
                                                      )
                                                }
                                                // value={
                                                //   brokerDetailsVal?.length
                                                //   ? brokerDetailsVal[0].DayRate.toString()
                                                //   :  0.00
                                                // }
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <span className="dollar-icon">
                                                      $
                                                    </span>
                                                  </InputAdornment>
                                                }
                                              />
                                            </FormControl>
                                            <FormControl variant="standard">
                                              <p className="label">Hours</p>
                                              <Input
                                                disabled={billingStatus}
                                                name={`${key}[${index}].hours`}
                                                onChange={(e) =>
                                                  handleChangeCustomHours(
                                                    e,
                                                    key,
                                                    index
                                                  )
                                                }
                                                value={item.hours}
                                                error={
                                                  errors[key]?.[index]?.hours &&
                                                  touched[key]?.[index]?.hours
                                                }
                                                helperText={
                                                  errors[key]?.[index]?.hours &&
                                                  touched[key]?.[index]?.hours
                                                    ? errors[key][index].hours
                                                    : ""
                                                }
                                                style={{
                                                  borderColor:
                                                    warningHighlighted &&
                                                    isFormDirty &&
                                                    changedFields[
                                                      `${key}[${index}].hours`
                                                    ]
                                                      ? "yellow"
                                                      : "",
                                                  outline:
                                                    warningHighlighted &&
                                                    isFormDirty &&
                                                    changedFields[
                                                      `${key}[${index}].hours`
                                                    ]
                                                      ? "yellow"
                                                      : "",
                                                  borderWidth:
                                                    warningHighlighted &&
                                                    isFormDirty &&
                                                    changedFields[
                                                      `${key}[${index}].hours`
                                                    ]
                                                      ? "1px"
                                                      : "",
                                                }}
                                              />
                                            </FormControl>
                                            <FormControl
                                              sx={{
                                                marginLeft: {
                                                  xs: "auto !important",
                                                  sm: "0px !important",
                                                  md: "0px !important",
                                                  lg: "12px !important",
                                                },
                                              }}
                                              variant="standard"
                                            >
                                              <p className="label">Miles</p>
                                              <Input
                                                sx={{
                                                  "&.MuiInputBase-root": {
                                                    border:
                                                      warningHighlighted &&
                                                      isFormDirty &&
                                                      changedFields[
                                                        `${key}[${index}].miles`
                                                      ]
                                                        ? "1px solid yellow"
                                                        : "",
                                                  },
                                                  "&:hover:not(.Mui-disabled):before":
                                                    {
                                                      borderBottom:
                                                        warningHighlighted &&
                                                        isFormDirty &&
                                                        changedFields[
                                                          `${key}[${index}].miles`
                                                        ]
                                                          ? "1px solid yellow"
                                                          : "",
                                                    },
                                                  "&.Mui-focused:after": {
                                                    borderBottom:
                                                      warningHighlighted &&
                                                      isFormDirty &&
                                                      changedFields[
                                                        `${key}[${index}].miles`
                                                      ]
                                                        ? "1px solid yellow"
                                                        : "",
                                                  },
                                                }}
                                                disabled={billingStatus}
                                                name={`${key}[${index}].miles`}
                                                onChange={(e) =>
                                                  handleChangeCustomIntNumber(
                                                    e,
                                                    key,
                                                    index
                                                  )
                                                }
                                                value={item.miles}
                                              />
                                            </FormControl>

                                            <FormControl variant="standard">
                                              <p className="label">Lodging</p>
                                              <Input
                                                sx={{
                                                  "&.MuiInputBase-root": {
                                                    border:
                                                      warningHighlighted &&
                                                      isFormDirty &&
                                                      changedFields[
                                                        `${key}[${index}].lodging`
                                                      ]
                                                        ? "1px solid yellow"
                                                        : "",
                                                  },
                                                  "&:hover:not(.Mui-disabled):before":
                                                    {
                                                      borderBottom:
                                                        warningHighlighted &&
                                                        isFormDirty &&
                                                        changedFields[
                                                          `${key}[${index}].lodging`
                                                        ]
                                                          ? "1px solid yellow"
                                                          : "",
                                                    },
                                                  "&.Mui-focused:after": {
                                                    borderBottom:
                                                      warningHighlighted &&
                                                      isFormDirty &&
                                                      changedFields[
                                                        `${key}[${index}].lodging`
                                                      ]
                                                        ? "1px solid yellow"
                                                        : "",
                                                  },
                                                }}
                                                className="dollar-field"
                                                disabled={billingStatus}
                                                name={`${key}[${index}].lodging`}
                                                onChange={(e) =>
                                                  handleChangeCustomFloatNumber(
                                                    e,
                                                    key,
                                                    index
                                                  )
                                                }
                                                value={item.lodging}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <span className="dollar-icon">
                                                      $
                                                    </span>
                                                  </InputAdornment>
                                                }
                                              />
                                            </FormControl>
                                            <FormControl variant="standard">
                                              <p className="label">Copies</p>
                                              <Input
                                                sx={{
                                                  "&.MuiInputBase-root": {
                                                    border:
                                                      warningHighlighted &&
                                                      isFormDirty &&
                                                      changedFields[
                                                        `${key}[${index}].copies`
                                                      ]
                                                        ? "1px solid yellow"
                                                        : "",
                                                  },
                                                  "&:hover:not(.Mui-disabled):before":
                                                    {
                                                      borderBottom:
                                                        warningHighlighted &&
                                                        isFormDirty &&
                                                        changedFields[
                                                          `${key}[${index}].copies`
                                                        ]
                                                          ? "1px solid yellow"
                                                          : "",
                                                    },
                                                  "&.Mui-focused:after": {
                                                    borderBottom:
                                                      warningHighlighted &&
                                                      isFormDirty &&
                                                      changedFields[
                                                        `${key}[${index}].copies`
                                                      ]
                                                        ? "1px solid yellow"
                                                        : "",
                                                  },
                                                }}
                                                className="dollar-field"
                                                disabled={billingStatus}
                                                name={`${key}[${index}].copies`}
                                                onChange={(e) =>
                                                  handleChangeCustomFloatNumber(
                                                    e,
                                                    key,
                                                    index
                                                  )
                                                }
                                                value={item.copies}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <span className="dollar-icon">
                                                      $
                                                    </span>
                                                  </InputAdornment>
                                                }
                                              />
                                            </FormControl>
                                          </Stack>
                                          <Stack
                                            direction={{
                                              xs: "column",
                                              sm: "row",
                                            }}
                                            spacing={{
                                              xs: 1,
                                              sm: 1.5,
                                              md: 1.5,
                                            }}
                                            justifyContent="space-between"
                                            sx={{
                                              alignItems: {
                                                xs: "flex-start",
                                                md: "flex-start",
                                              },
                                              mt: 1.5,
                                              display: {
                                                xs: "unset",
                                                sm: "grid",
                                                md: "grid",
                                                lg: "flex",
                                              },
                                              gridTemplateColumns: {
                                                xs: "unset",
                                                sm: "repeat(2, 1fr)",
                                                md: "repeat(2, 1fr)",
                                                lg: "unset",
                                              },
                                              rowGap: "10px !important",
                                            }}
                                          >
                                            <FormControl
                                              sx={{
                                                maxWidth: {
                                                  xs: "100%",
                                                  sm: "300px",
                                                },
                                                width: "100%",
                                              }}
                                              variant="standard"
                                            >
                                              <p className="label">
                                                Description
                                              </p>
                                              <div className="billing-textarea">
                                                <div class="pull-tab"></div>
                                                <textarea
                                                  style={{
                                                    resize: "vertical",
                                                    overflow: "auto",
                                                    outline:
                                                      warningHighlighted &&
                                                      isFormDirty &&
                                                      changedFields[
                                                        `${key}[${index}].description`
                                                      ]
                                                        ? "2px solid yellow"
                                                        : "",
                                                  }}
                                                  disabled={billingStatus}
                                                  id="outlined-multiline-static"
                                                  // multiline
                                                  // rows={2}
                                                  rows="4"
                                                  // defaultValue=""
                                                  placeholder="Write Description"
                                                  name={`${key}[${index}].description`}
                                                  onChange={() =>
                                                    handleChange1(
                                                      event,
                                                      key,
                                                      index
                                                    )
                                                  }
                                                  value={item.description}
                                                />
                                              </div>
                                            </FormControl>
                                            <FormControl
                                              sx={{ minWidth: "135px" }}
                                              variant="standard"
                                            >
                                              <p className="label">
                                                Per Diem Rate
                                              </p>
                                              {billingStatus ? (
                                                <Input
                                                  sx={{
                                                    "&.MuiInputBase-root": {
                                                      border:
                                                        warningHighlighted &&
                                                        isFormDirty &&
                                                        changedFields[
                                                          `${key}[${index}].copies`
                                                        ]
                                                          ? "1px solid yellow"
                                                          : "",
                                                    },
                                                    "&:hover:not(.Mui-disabled):before":
                                                      {
                                                        borderBottom:
                                                          warningHighlighted &&
                                                          isFormDirty &&
                                                          changedFields[
                                                            `${key}[${index}].perDiemRate`
                                                          ]
                                                            ? "1px solid yellow"
                                                            : "",
                                                      },
                                                    "&.Mui-focused:after": {
                                                      borderBottom:
                                                        warningHighlighted &&
                                                        isFormDirty &&
                                                        changedFields[
                                                          `${key}[${index}].perDiemRate`
                                                        ]
                                                          ? "1px solid yellow"
                                                          : "",
                                                    },
                                                  }}
                                                  className="dollar-field"
                                                  disabled={billingStatus}
                                                  name={`${key}[${index}].perDiemRate`}
                                                  onChange={(e) =>
                                                    handleChangeCustomFloatNumber(
                                                      e,
                                                      key,
                                                      index
                                                    )
                                                  }
                                                  value={
                                                    !isNaN(
                                                      parseFloat(
                                                        item?.perDiemRate
                                                      )
                                                    )
                                                      ? parseFloat(
                                                          item.perDiemRate
                                                        ).toFixed(2)
                                                      : "0.00"
                                                  }
                                                  startAdornment={
                                                    <InputAdornment position="start">
                                                      <span className="dollar-icon">
                                                        $
                                                      </span>
                                                    </InputAdornment>
                                                  }
                                                />
                                              ) : (
                                                <Select
                                                  className="dollar-field per-diem-rate-field"
                                                  sx={{
                                                    p: "0px !important",
                                                    "& .MuiInputBase-root.MuiInput-root":
                                                      {
                                                        // For the standard variant, use borderBottom to apply the border color
                                                        "&:before": {
                                                          borderBottom:
                                                            warningHighlighted &&
                                                            isFormDirty &&
                                                            changedFields[
                                                              `${key}[${index}].perDiemRate`
                                                            ]
                                                              ? "2px solid yellow"
                                                              : "",
                                                        },
                                                        "&:hover:not(.Mui-disabled):before":
                                                          {
                                                            borderBottom:
                                                              warningHighlighted &&
                                                              isFormDirty &&
                                                              changedFields[
                                                                `${key}[${index}].perDiemRate`
                                                              ]
                                                                ? "2px solid yellow"
                                                                : "",
                                                          },
                                                        "&.Mui-focused:after": {
                                                          borderBottom:
                                                            warningHighlighted &&
                                                            isFormDirty &&
                                                            changedFields[
                                                              `${key}[${index}].perDiemRate`
                                                            ]
                                                              ? "2px solid yellow"
                                                              : "",
                                                        },
                                                      },
                                                    "& .MuiSelect-select": {
                                                      color:
                                                        item.billingType ===
                                                          "" || item.billingType
                                                          ? "#212121"
                                                          : "#898989",
                                                    },
                                                  }}
                                                  disabled={billingStatus}
                                                  defaultValue={
                                                    !isNaN(
                                                      parseFloat(
                                                        item?.perDiemRate
                                                      )
                                                    )
                                                      ? parseFloat(
                                                          item.perDiemRate
                                                        ).toFixed(2)
                                                      : "0.00"
                                                  }
                                                  IconComponent={
                                                    KeyboardArrowDownIcon
                                                  }
                                                  id="grouped-select"
                                                  name={`${key}[${index}].perDiemRate`}
                                                  onChange={(event) =>
                                                    handleChange1(
                                                      event,
                                                      key,
                                                      index
                                                    )
                                                  }
                                                  value={
                                                    !isNaN(
                                                      parseFloat(
                                                        item?.perDiemRate
                                                      )
                                                    )
                                                      ? parseFloat(
                                                          item.perDiemRate
                                                        ).toFixed(2)
                                                      : "0.00"
                                                  }
                                                  startAdornment={
                                                    <InputAdornment position="start">
                                                      <span className="dollar-icon">
                                                        $
                                                      </span>
                                                    </InputAdornment>
                                                  }
                                                >
                                                  {/* Check if item.perDiemRate is not in the predefined options and add it as a separate MenuItem */}
                                                  {/* {item.perDiemRate &&
                                                    ![
                                                      "0",
                                                      brokerDetailsVal?.[0]?.PayableOfficePerDiem?.toString(),
                                                      brokerDetailsVal?.[0]?.PayableTravelPerDiem?.toString(),
                                                    ].includes(
                                                      item.perDiemRate.toString()
                                                    ) && (
                                                      <MenuItem
                                                        value={item.perDiemRate.toString()}
                                                        disabled
                                                      >
                                                        {item.perDiemRate.toString()}
                                                      </MenuItem>
                                                    )} */}

                                                  <ListSubheader className="per-diem-header">
                                                    N/A
                                                  </ListSubheader>
                                                  <MenuItem
                                                    onClick={(e) =>
                                                      handleOnClickPer(
                                                        e,
                                                        key,
                                                        index,
                                                        "IsEmpty"
                                                      )
                                                    }
                                                    value="0.00"
                                                  >
                                                    0.00
                                                  </MenuItem>
                                                  <ListSubheader className="per-diem-header">
                                                    Office Per Diem
                                                  </ListSubheader>
                                                  <MenuItem
                                                    onClick={(e) =>
                                                      handleOnClickPer(
                                                        e,
                                                        key,
                                                        index,
                                                        "IsOfficePerDiem"
                                                      )
                                                    }
                                                    value={
                                                      orphanedBillingDetail?.length >
                                                      0
                                                        ? orphanedBillingDetail[0].PayableOfficePerDiem.toFixed(
                                                            2
                                                          )
                                                        : brokerDetailsVal?.[0]
                                                            ?.PayableOfficePerDiem
                                                        ? BillableOfficePerDiem
                                                          ? BillableOfficePerDiem.toFixed(
                                                              2
                                                            )
                                                          : "0.00"
                                                        : "0.00"
                                                    }
                                                  >
                                                    {orphanedBillingDetail?.length >
                                                    0
                                                      ? orphanedBillingDetail[0].PayableOfficePerDiem.toFixed(
                                                          2
                                                        )
                                                      : brokerDetailsVal?.[0]
                                                          ?.PayableOfficePerDiem
                                                      ? BillableOfficePerDiem
                                                        ? BillableOfficePerDiem.toFixed(
                                                            2
                                                          )
                                                        : "0.00"
                                                      : "0.00"}
                                                  </MenuItem>
                                                  {/* <MenuItem
                                                  value={
                                                    brokerDetailsVal?.length
                                                      ? brokerDetailsVal[0].PayableOfficePerDiem.toString()
                                                      : BillableOfficePerDiem
                                                      ? BillableOfficePerDiem.toString()
                                                      : "0"
                                                  }
                                                >
                                                  {brokerDetailsVal?.length
                                                    ? brokerDetailsVal[0].PayableOfficePerDiem
                                                    : BillableOfficePerDiem}
                                                </MenuItem> */}
                                                  <ListSubheader className="per-diem-header">
                                                    Travel Per Diem
                                                  </ListSubheader>
                                                  <MenuItem
                                                    onClick={(e) =>
                                                      handleOnClickPer(
                                                        e,
                                                        key,
                                                        index,
                                                        "IsTravelPerDiem"
                                                      )
                                                    }
                                                    value={
                                                      orphanedBillingDetail?.length >
                                                      0
                                                        ? orphanedBillingDetail[0].PayableTravelPerDiem.toFixed(
                                                            2
                                                          )
                                                        : brokerDetailsVal?.[0]
                                                            ?.PayableTravelPerDiem
                                                        ? BillableTravelPerDiem
                                                          ? BillableTravelPerDiem.toFixed(
                                                              2
                                                            )
                                                          : "0.00"
                                                        : "0.00"
                                                    }
                                                  >
                                                    {orphanedBillingDetail?.length >
                                                    0
                                                      ? orphanedBillingDetail[0].PayableTravelPerDiem?.toFixed(
                                                          2
                                                        )
                                                      : brokerDetailsVal?.[0]
                                                          ?.PayableTravelPerDiem
                                                      ? BillableTravelPerDiem?.toFixed(
                                                          2
                                                        )
                                                      : "0.00"}
                                                  </MenuItem>

                                                  {/* <MenuItem
                                                  value={
                                                    brokerDetailsVal?.length
                                                      ? brokerDetailsVal[0].PayableTravelPerDiem.toString()
                                                      : BillableTravelPerDiem
                                                      ? BillableTravelPerDiem.toString()
                                                      : "0"
                                                  }
                                                >
                                                  {brokerDetailsVal?.length
                                                    ? brokerDetailsVal[0].PayableTravelPerDiem
                                                    : BillableTravelPerDiem}
                                                </MenuItem> */}
                                                </Select>
                                              )}
                                            </FormControl>

                                            <FormControl
                                              sx={{
                                                marginLeft: {
                                                  xs: "auto !important",
                                                  sm: "0px !important",
                                                  md: "0px !important",
                                                  lg: "12px !important",
                                                },
                                              }}
                                              variant="standard"
                                            >
                                              <p className="label">Per Diem</p>
                                              <Input
                                                className="dollar-field"
                                                name={`${key}[${index}].perDiem`}
                                                onChange={handleChangeperdiem}
                                                value={calculatePerDiem(
                                                  item.hours,
                                                  item.perDiemRate
                                                )}
                                                disabled
                                                // onChange={handleChange}
                                                // disabled={editFlag}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <span className="dollar-icon">
                                                      $
                                                    </span>
                                                  </InputAdornment>
                                                }
                                              />
                                            </FormControl>
                                            <FormControl variant="standard">
                                              <p className="label">Misc</p>
                                              <Input
                                                sx={{
                                                  "&.MuiInputBase-root": {
                                                    border:
                                                      warningHighlighted &&
                                                      isFormDirty &&
                                                      changedFields[
                                                        `${key}[${index}].misc`
                                                      ]
                                                        ? "1px solid yellow"
                                                        : "",
                                                  },
                                                  "&:hover:not(.Mui-disabled):before":
                                                    {
                                                      borderBottom:
                                                        warningHighlighted &&
                                                        isFormDirty &&
                                                        changedFields[
                                                          `${key}[${index}].misc`
                                                        ]
                                                          ? "1px solid yellow"
                                                          : "",
                                                    },
                                                  "&.Mui-focused:after": {
                                                    borderBottom:
                                                      warningHighlighted &&
                                                      isFormDirty &&
                                                      changedFields[
                                                        `${key}[${index}].misc`
                                                      ]
                                                        ? "1px solid yellow"
                                                        : "",
                                                  },
                                                }}
                                                className="dollar-field"
                                                disabled={billingStatus}
                                                name={`${key}[${index}].misc`}
                                                onChange={(e) =>
                                                  handleChangeCustomFloatNumber(
                                                    e,
                                                    key,
                                                    index
                                                  )
                                                }
                                                value={item.misc}
                                                startAdornment={
                                                  <InputAdornment position="start">
                                                    <span className="dollar-icon">
                                                      $
                                                    </span>
                                                  </InputAdornment>
                                                }
                                              />
                                            </FormControl>
                                          </Stack>
                                        </Box>
                                      </Box>
                                    );
                                  })
                                )}
                          </form>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </Box>
                {/* <div>
                  {Object.keys(values).map((dateKey) => (
                    <div key={dateKey}>
                      <h3>{dateKey}</h3>
                      {values[dateKey] &&
                        values[dateKey].map((item, index) => (
                          <div key={index} className="item">
                            <p>Billing Type: {item.billingType}</p>
                            <p>Day Rate: {item.dayRate}</p>
                            <p>Hours: {item.hours}</p>
                            <p>Miles: {item.miles}</p>
                            <p>Lodging: {item.lodging}</p>
                            <p>Description: {item.description}</p>
                            <p>Date: {item.date}</p>
                            <p>Copies: {item.copies}</p>
                            <p>Per Diem Rate: {item.perDiemRate}</p>
                            <p>Per Diem: {item.perDiem}</p>
                          </div>
                        ))}
                    </div>
                  ))}
                </div> */}
              </Box>
            </Grid>
            <Grid xs={12} md={3}>
              <Box
                sx={{
                  ml: "20px",
                  p: "16px 15px",
                  pb: "10px",
                  position: { xs: "unset", sm: "sticky" },
                  top: "0px",
                  zIndex: "9",
                }}
                className="bg-box"
              >
                <Button
                  className="viewedit-btn"
                  variant="outlined"
                  startIcon={
                    <span class="material-symbols-outlined">edit</span>
                  }
                  onClick={() => {
                    handleAttachmentOpen(true);
                  }}
                  disabled={billingStatementDetail.hprojectID ? false : true}
                >
                  View/edit attachments
                </Button>
                <Button
                  className="print-btn"
                  variant="outlined"
                  startIcon={
                    <span class="material-symbols-outlined">print</span>
                  }
                  onClick={handlePrintBillingStatement}
                >
                  Print Billing Statement
                </Button>
                {billingStatus == false ? (
                  <Button
                    className="reopen-btn"
                    variant="outlined"
                    onClick={() => handleBillingStatus("closeBilling")}
                    disabled={closeStatementButton}
                    startIcon={
                      <span class="material-symbols-outlined">
                        receipt_long
                      </span>
                    }
                  >
                    Close Billing Statement
                  </Button>
                ) : activeStep == 1 ? (
                  <Button
                    className="reopen-btn"
                    variant="outlined"
                    startIcon={
                      <span class="material-symbols-outlined">
                        receipt_long
                      </span>
                    }
                    onClick={() => reopenBillFun("reopenBilling")}
                  >
                    Reopen Billing Statement
                  </Button>
                ) : (
                  activeStep == 2 && (
                    <Tooltip
                      title="Cannot reopen an invoiced billing statement"
                      arrow
                      placement="top"
                    >
                      <Button
                        className="notopen-btn"
                        variant="outlined"
                        onClick={handleCannotOpen}
                        startIcon={
                          <span className="material-symbols-outlined">
                            receipt_long
                          </span>
                        }
                        disabled={reOpenLoading}
                      >
                        Cannot Reopen
                      </Button>
                    </Tooltip>
                  )
                )}
              </Box>

              {openAttachmentFilter && (
                <BillingAttachment
                  open={openAttachmentFilter}
                  handleClose={handleAttachmentClose}
                  billingId={id}
                  activeStep={activeStep}
                  IsorphanedPage={"orphanedPage"}
                  // filterValue={filter}
                  // setFilterValue={setFilter}
                  // filterInitial={filterInitial}
                  // applyFilterFun={applyFilterFun}
                  billingStatementDetail={billingStatementDetail}
                />
              )}

              {itemRemoveConfirmStatus && (
                <Dialog
                  className="user-filter-popup project-filters"
                  sx={{
                    width: "100% !important",
                    height: "100%",
                    maxHeight: "fit-co",
                  }}
                  // fullScreen={fullScreen}
                  open={itemRemoveConfirmStatus}
                  //  onClose={handleChangeno}
                  aria-labelledby="responsive-dialog-title"
                >
                  <Stack
                    sx={{ p: "25px 25px", pb: "4px" }}
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    justifyContent="space-between"
                  >
                    <Typography className="model-title">
                      Remove Confirmation
                    </Typography>
                  </Stack>
                  <Box sx={{ p: "0px 25px 0px 25px" }}>
                    <p className="label">
                      Are you sure you want to remove this '
                      {itemRemoveConfirmItem.date}' item?
                    </p>
                  </Box>
                  <DialogActions
                    sx={{
                      justifyContent: "flex-start",
                      p: "20px 25px",
                      pt: "21px",
                    }}
                  >
                    <Button
                      className="filter-btn"
                      onClick={() => removeItemFuncConfirm(true)}
                    >
                      Yes
                    </Button>
                    <Button
                      className="cancel-btn"
                      onClick={() => removeItemFuncConfirm(false)}
                    >
                      No
                    </Button>
                  </DialogActions>
                </Dialog>
              )}

              {showWarning && (
                <Dialog
                  className="user-filter-popup project-filters"
                  sx={{
                    width: "100% !important",
                    height: "100%",
                    maxHeight: "fit-co",
                  }}
                  // fullScreen={fullScreen}
                  open={showWarning || !formSaved}
                  //  onClose={handleChangeno}
                >
                  <Stack
                    sx={{ p: "25px 25px", pb: "4px" }}
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    justifyContent="flex-start"
                  >
                    <ErrorIcon
                      fontSize="inherit"
                      style={{ color: "#007FFF", fontSize: "24px" }}
                    />
                    <Typography
                      className="model-title"
                      sx={{ ml: "5px !important" }}
                    >
                      Warning: Unsaved Changes
                    </Typography>
                  </Stack>
                  <Box sx={{ p: "0px 34px 0px 34px" }}>
                    <p className="label">
                      You have unsaved changes. Unsaved changes will be lost if
                      you proceed. Are you sure you want to continue?
                    </p>
                  </Box>
                  <DialogActions
                    sx={{
                      justifyContent: "flex-start",
                      p: "20px 25px",
                      pt: "21px",
                    }}
                  >
                    <Button
                      className="filter-btn"
                      onClick={() => handleYesClick()}
                    >
                      Proceed
                    </Button>
                    <Button className="cancel-btn" onClick={handleNoClick}>
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
